@if (showSpinner) {
<app-loader> </app-loader>
}
@if ((isSidebarVisible) || (theme_id == 1 || theme_id ==2 )) {
<div class="navbar-waraper">
  <div class="top-navbar">
    <div class="logo-section">
      <img src="../../../../assets/theme1/new-logo.png" alt="logo missing" class="light-logo" />
      <img src="../../../../assets/theme1/dark-logo.png" alt="logo missing" class="dark-logo" style="display: none;" />
    </div>
    <div class="top-navbar-body">
      <div class="top-nav-heading">
        <h1>Welcome {{ user.first_name}} {{user.last_name}}</h1>
      </div>
      <div class="top-nav-details">
        @if (user.org_admin == 1) {
        <div class="user-profile-section" (click)="toggleorgDropdown()">
          <img src="../../../../assets/images/org_admin.svg" alt="image missing" />
          <div class="user-detail-section">
            <p>{{ user.organization.name}} </p>
            <span>Select Orgnization</span>
          </div>
          <svg class="drop-icon" width="14" height="8" viewBox="0 0 14 8" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L7 7L13 1" stroke="#555555" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M1 1L7 7L13 1" stroke="black" stroke-opacity="0.2" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
          @if (isOrgdownVisible) {
          <div class="drop-down-section">
            <ul>
              @for (org of orgnizations; track org) {
              <li (click)="changeOrgnization(org.id)">
                <a>
                  <div class="svg-icon">
                    <svg width="16" height="16">
                      <circle cx="8" cy="8" r="7" stroke="#555" />
                    </svg>
                  </div>
                  <p>{{ org.name }}</p>
                </a>
              </li>
              }
            </ul>
          </div>
          }
        </div>
        }
        <div class="notifications" (click)="toggleNotify()">
          <svg width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M7.35419 20C8.05933 20.6224 8.98557 21 10 21C11.0145 21 11.9407 20.6224 12.6458 20M16 7C16 5.4087 15.3679 3.88258 14.2427 2.75736C13.1174 1.63214 11.5913 1 10 1C8.40872 1 6.8826 1.63214 5.75738 2.75736C4.63216 3.88258 4.00002 5.4087 4.00002 7C4.00002 10.0902 3.22049 12.206 2.34968 13.6054C1.61515 14.7859 1.24788 15.3761 1.26134 15.5408C1.27626 15.7231 1.31488 15.7926 1.46179 15.9016C1.59448 16 2.19261 16 3.38887 16H16.6112C17.8074 16 18.4056 16 18.5382 15.9016C18.6852 15.7926 18.7238 15.7231 18.7387 15.5408C18.7522 15.3761 18.3849 14.7859 17.6504 13.6054C16.7795 12.206 16 10.0902 16 7Z"
              stroke="#555555" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path
              d="M7.35419 20C8.05933 20.6224 8.98557 21 10 21C11.0145 21 11.9407 20.6224 12.6458 20M16 7C16 5.4087 15.3679 3.88258 14.2427 2.75736C13.1174 1.63214 11.5913 1 10 1C8.40872 1 6.8826 1.63214 5.75738 2.75736C4.63216 3.88258 4.00002 5.4087 4.00002 7C4.00002 10.0902 3.22049 12.206 2.34968 13.6054C1.61515 14.7859 1.24788 15.3761 1.26134 15.5408C1.27626 15.7231 1.31488 15.7926 1.46179 15.9016C1.59448 16 2.19261 16 3.38887 16H16.6112C17.8074 16 18.4056 16 18.5382 15.9016C18.6852 15.7926 18.7238 15.7231 18.7387 15.5408C18.7522 15.3761 18.3849 14.7859 17.6504 13.6054C16.7795 12.206 16 10.0902 16 7Z"
              stroke="black" stroke-opacity="0.2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          @if (notify_counts > 0) {
          <div class="notify-mark">
            <p>{{this.totalCount}}</p>
          </div>
          }
          @if (isNotifyOpen) {
          <div class="notify-dropdown" #dropdownRef>
            <div class="notify-dropdown-head">
              <h1>Notifications</h1>
            </div>
            <div class="notify-dropdown-body mt-3">
              @for (data of notifyData; track data) {
              <!-- leave -->
              @if (['Leave Request'].includes(data.req_type)) {
              <div class="notify-content-main " [ngClass]="{ 'notify-active': data.req_notifications[0].is_read == 0 }">
                <div class="notify-content" (click)="data.req_notifications[0].is_read == 0 && clearnotifications(data.req_notifications[0].notification_id)">
                  <div class="notify-content-left">
                    <img [src]="parseJson(data.data).sender_user.profile_image" alt="Missing" />
                  </div>
                  <div class="notify-content-right">
                    <h1>{{data.req_type}}</h1>
                    <p>{{ formatDate(parseJson(data.data).date) }}</p>
                    <div class="notify-inner-sec">
                      <h4>
                        <span> {{ parseJson(data.data).sender_user.first_name }} {{
                          parseJson(data.data).sender_user.last_name }}</span>
                        has requested <span>{{ parseJson(data.data).title[0] }}</span> on {{
                        formatOnlyDate(parseJson(data.data).date) }}.
                      </h4>
                    </div>
                    @if (data.leave.leavenotify[0].status == '1') {
                    <p class="approve-label">
                      <span class="span-color-approve-label"> Action Is Alreadyy Performed.</span>
                    </p>
                    }
                  </div>
                  @if ( data.req_notifications[0].is_read == 0) {
                  <div class="active-section">
                    <div class="div-cirlce">
                    </div>
                  </div>
                  }
                </div>
                @if (data.leave.status === 'pending' || data.leave.leavenotify[0].status == '0') {
                <div class="notify-action-button" (click)="$event.stopPropagation()">
                  <!-- <div class="notify-action-button" (click)="$event.stopPropagation()"> -->
                  @if (leaveReject && activeRejectId != parseJson(data.data).type_id ||
                  isavailablefeatureforLeave('isReject')) {
                  <div class="notify-button reject-action-btn" (click)="toggleRejectBox(parseJson(data.data).type_id)">
                    Reject
                    <!-- {{parseJson(data.data).title[1]}} -->
                  </div>
                  }
                  @if (leaveaccept && activeRejectId != parseJson(data.data).type_id ||
                  isavailablefeatureforLeave('isAccept')) {
                  <div class="notify-button accept-action-btn" (click)="approveleave(data)">
                    {{getApprovalButtonLabel(data.leave)}}
                  </div>
                  }
                  @if (activeRejectId == parseJson(data.data).type_id) {
                  <div class="col-12 mt-2 mb-2 text-box">
                    <textarea class="form-control" id="rejected_reason" rows="3" name="rejected_reason"
                      placeholder="Enter Reason" [(ngModel)]="rejectedReason" #r="ngModel" required>
                                      </textarea>
                    @if (rejectedReason && rejectedReason.length < 50) { <div class="alert alert-warning mt-2">
                      Ensure that the entered <strong>Reason</strong> contains minimum of 50 characters.
                  </div>
                  }
                  @if (leaveRejectionData.length > 0) {
                  <div class="mt-4">
                    @for (item of leaveRejectionData; track item) {
                    <div>
                      <p class="truncate clickable" (click)="setReason(item.text)">{{ item.text }}</p>
                    </div>
                    }
                  </div>
                  }
                  <div class="mt-3 d-flex justify-content-between">
                    <button class="notify-button accept-action-btn" [disabled]=" rejectedReason.length < 50"
                      (click)="reject()">
                      Submit Rejection
                    </button>
                    <button class="notify-button reject-action-btn"
                      (click)="toggleRejectBox(parseJson(data.data).type_id)">Cancel</button>
                  </div>
                </div>
                }
              </div>
              }
            </div>
            }
            @if (['Leave Request Edited' ].includes(data.req_type)) {
            <div class="notify-content-main content-display"
              [ngClass]="{ 'notify-active': data.req_notifications[0].is_read == 0 }"
              (click)="data.req_notifications[0].is_read == 0 && clearnotifications(data.req_notifications[0].notification_id)">
              <div class="notify-content-left">
                <img [src]="parseJson(data.data).sender_user.profile_image" alt="Profile Image" />
              </div>
              <div class="notify-content-right">
                <!-- <h1>{{parseJson(data.data).title}}</h1> -->
                <h1>{{data.req_type}}</h1>
                <p>{{ formatDate(parseJson(data.data).date) }}</p>
                <div class="notify-inner-sec">
                  <h4>
                    <span>{{ parseJson(data.data).sender_user.first_name }} {{
                      parseJson(data.data).sender_user.last_name }}</span>
                    has Edited <span>{{ parseJson(data.data).title.split(',')[1] }}</span> on {{
                    formatOnlyDate(parseJson(data.data).date) }}.
                  </h4>
                </div>
              </div>
              @if ( data.req_notifications[0].is_read == 0) {
              <div class="active-section">
                <div class="div-cirlce">
                </div>
              </div>
              }
            </div>
            }
            @if (['Leave Request Deleted' ].includes(data.req_type)) {
            <div class="notify-content-main content-display"
              [ngClass]="{ 'notify-active': data.req_notifications[0].is_read == 0 }"
              (click)="data.req_notifications[0].is_read == 0 && clearnotifications(data.req_notifications[0].notification_id)">
              <div class="notify-content-left">
                <img [src]="parseJson(data.data).sender_user.profile_image" alt="Profile Image" />
              </div>
              <div class="notify-content-right">
                <!-- <h1>{{parseJson(data.data).title}}</h1> -->
                <h1>{{data.req_type}}</h1>
                <p>{{ formatDate(parseJson(data.data).date) }}</p>
                <div class="notify-inner-sec">
                  <h4>
                    <span>{{ parseJson(data.data).sender_user.first_name }} {{
                      parseJson(data.data).sender_user.last_name }}</span>
                    has Deleted <span>{{ parseJson(data.data).title.split(',')[1] }}</span> on {{
                    formatOnlyDate(parseJson(data.data).date) }}.
                  </h4>
                </div>
              </div>
              @if ( data.req_notifications[0].is_read == 0) {
              <div class="active-section">
                <div class="div-cirlce">
                </div>
              </div>
              }
            </div>
            }
            @if (['Approve Leave'].includes(data.req_type) && showAdmintab) {
            <div class="notify-content-main content-display"
              [ngClass]="{ 'notify-active': data.req_notifications[0].is_read == 0 }"
              (click)="data.req_notifications[0].is_read == 0 && clearnotifications(data.req_notifications[0].notification_id)">
              <div class="notify-content-left">
                <img [src]="parseJson(data.data).sender_user.profile_image" alt="Profile Image" />
                <div class="action-circle">
                  <img src="../../../../assets/theme1/tick.png" alt="Profile Image" />
                </div>
              </div>
              <div class="notify-content-right">
                <!-- <h1>{{parseJson(data.data).title}}</h1> -->
                <h1>{{data.req_type}}</h1>
                <p>{{ formatDate(parseJson(data.data).date) }}</p>
                <div class="notify-inner-sec">
                  <h4>
                    <span>{{ parseJson(data.data).sender_user.first_name }} {{
                      parseJson(data.data).sender_user.last_name }}</span>
                    had <span>{{ parseJson(data.data).title[0] }}</span> of <span>{{
                      parseJson(data.data).title[1] }}</span> on {{ formatOnlyDate(parseJson(data.data).date)
                    }}.
                  </h4>
                </div>
              </div>
              @if ( data.req_notifications[0].is_read == 0) {
              <div class="active-section">
                <div class="div-cirlce">
                </div>
              </div>
              }
            </div>
            }
            @if (['Approve Leave'].includes(data.req_type) && EmployeeTab) {
            <div class="notify-content-main content-display"
              [ngClass]="{ 'notify-active': data.req_notifications[0].is_read == 0 }"
              (click)="data.req_notifications[0].is_read == 0 && clearnotifications(data.req_notifications[0].notification_id)">
              <div class="notify-content-left">
                <img [src]="parseJson(data.data).sender_user.profile_image" alt="Profile Image" />
                <div class="action-circle">
                  <img src="../../../../assets/theme1/tick.png" alt="Profile Image" />
                </div>
              </div>
              <div class="notify-content-right">
                <!-- <h1>{{parseJson(data.data).title}}</h1> -->
                <h1>{{data.req_type}}</h1>
                <p>{{ formatDate(parseJson(data.data).date) }}</p>
                <div class="notify-inner-sec">
                  <h4>
                    <span>{{ parseJson(data.data).sender_user.first_name }} {{
                      parseJson(data.data).sender_user.last_name }}</span>
                    had <span>{{ parseJson(data.data).title[0] }}</span> on {{
                    formatOnlyDate(parseJson(data.data).date) }}.
                  </h4>
                </div>
              </div>
              @if ( data.req_notifications[0].is_read == 0) {
              <div class="active-section">
                <div class="div-cirlce">
                </div>
              </div>
              }
            </div>
            }
            @if (['Rejected Leave'].includes(data.req_type) && showAdmintab) {
            <div class="notify-content-main content-display"
              [ngClass]="{ 'notify-active': data.req_notifications[0].is_read == 0 }"
              (click)="data.req_notifications[0].is_read == 0 && clearnotifications(data.req_notifications[0].notification_id)">
              <div class="notify-content-left">
                <img [src]="parseJson(data.data).sender_user.profile_image" alt="Profile Image" />
                <div class="action-circle">
                  <img src="../../../../assets/theme1/coss.png" alt="Profile Image" />
                </div>
              </div>
              <div class="notify-content-right">
                <!-- <h1>{{parseJson(data.data).title}}</h1> -->
                <h1>{{data.req_type}}</h1>
                <p>{{ formatDate(parseJson(data.data).date) }}</p>
                <div class="notify-inner-sec">
                  <h4>
                    <span>{{ parseJson(data.data).sender_user.first_name }} {{
                      parseJson(data.data).sender_user.last_name }}</span>
                    had <span>{{ parseJson(data.data).title[0] }}</span> of <span>{{
                      parseJson(data.data).title[1] }}</span> on {{ formatOnlyDate(parseJson(data.data).date)
                    }}.
                  </h4>
                </div>
              </div>
              @if ( data.req_notifications[0].is_read == 0) {
              <div class="active-section">
                <div class="div-cirlce">
                </div>
              </div>
              }
            </div>
            }
            @if (['Rejected Leave'].includes(data.req_type) && EmployeeTab) {
            <div class="notify-content-main content-display"
              [ngClass]="{ 'notify-active': data.req_notifications[0].is_read == 0 }"
              (click)="data.req_notifications[0].is_read == 0 && clearnotifications(data.req_notifications[0].notification_id)">
              <div class="notify-content-left">
                <img [src]="parseJson(data.data).sender_user.profile_image" alt="Profile Image" />
                <div class="action-circle">
                  <img src="../../../../assets/theme1/coss.png" alt="Profile Image" />
                </div>
              </div>
              <div class="notify-content-right">
                <!-- <h1>{{parseJson(data.data).title}}</h1> -->
                <h1>{{data.req_type}}</h1>
                <p>{{ formatDate(parseJson(data.data).date) }}</p>
                <div class="notify-inner-sec">
                  <h4>
                    <span>{{ parseJson(data.data).sender_user.first_name }} {{
                      parseJson(data.data).sender_user.last_name }}</span>
                    had <span>{{ parseJson(data.data).title[0] }}</span> on {{
                    formatOnlyDate(parseJson(data.data).date) }}.
                  </h4>
                </div>
              </div>
              @if ( data.req_notifications[0].is_read == 0) {
              <div class="active-section">
                <div class="div-cirlce">
                </div>
              </div>
              }
            </div>
            }
            @if (['Updated Leave'].includes(data.req_type) && showAdmintab) {
            <div class="notify-content-main content-display"
              [ngClass]="{ 'notify-active': data.req_notifications[0].is_read == 0 }"
              (click)="data.req_notifications[0].is_read == 0 && clearnotifications(data.req_notifications[0].notification_id)">
              <div class="notify-content-left">
                <img [src]="parseJson(data.data).sender_user.profile_image" alt="Profile Image" />
              </div>
              <div class="notify-content-right">
                <!-- <h1>{{parseJson(data.data).title}}</h1> -->
                <h1>{{data.req_type}}</h1>
                <p>{{ formatDate(parseJson(data.data).date) }}</p>
                <div class="notify-inner-sec">
                  <h4>
                    <span>{{ parseJson(data.data).sender_user.first_name }} {{
                      parseJson(data.data).sender_user.last_name }}</span>
                    had <span>{{ parseJson(data.data).title[0] }}</span> of <span>{{
                      parseJson(data.data).title[1] }}</span> on {{ formatOnlyDate(parseJson(data.data).date)
                    }}.
                  </h4>
                </div>
              </div>
              @if ( data.req_notifications[0].is_read == 0) {
              <div class="active-section">
                <div class="div-cirlce">
                </div>
              </div>
              }
            </div>
            }
            @if (['Updated Leave'].includes(data.req_type) && EmployeeTab) {
            <div class="notify-content-main content-display"
              [ngClass]="{ 'notify-active': data.req_notifications[0].is_read == 0 }"
              (click)="data.req_notifications[0].is_read == 0 && clearnotifications(data.req_notifications[0].notification_id)">
              <div class="notify-content-left">
                <img [src]="parseJson(data.data).title[3] " alt="Profile Image" />
              </div>
              <div class="notify-content-right">
                <!-- <h1>{{parseJson(data.data).title}}</h1> -->
                <h1>{{data.req_type}}</h1>
                <p>{{ formatDate(parseJson(data.data).date) }}</p>
                <div class="notify-inner-sec">
                  <h4>
                    <span>{{ parseJson(data.data).sender_user.first_name }} {{
                      parseJson(data.data).sender_user.last_name }}</span>
                    had <span>{{ parseJson(data.data).title[0] }}</span> on {{
                    formatOnlyDate(parseJson(data.data).date) }}.
                  </h4>
                </div>
              </div>
              @if ( data.req_notifications[0].is_read == 0) {
              <div class="active-section">
                <div class="div-cirlce">
                </div>
              </div>
              }
            </div>
            }
            <!-- Attendance  -->
            @if (['Attendance Correction' ].includes(data.req_type) ) {
            <div class="notify-content-main content-display"
              [ngClass]="{ 'notify-active': data.req_notifications[0].is_read == 0 }"
              (click)="data.req_notifications[0].is_read == 0 && clearnotifications(data.req_notifications[0].notification_id)">
              <div class="notify-content-left">
                <img [src]="parseJson(data.data).sender_user.profile_image" alt="Profile Image" />
              </div>
              <div class="notify-content-right">
                <!-- <h1>{{parseJson(data.data).title}}</h1> -->
                <h1>{{data.req_type}}</h1>
                <p>{{ formatDate(parseJson(data.data).date) }}</p>
                <div class="notify-inner-sec">
                  <h4>
                    <span>{{ parseJson(data.data).sender_user.first_name }} {{
                      parseJson(data.data).sender_user.last_name }}</span>
                    has request for
                    @if (parseJson(data.data).title === 'check_in') {
                    <span>Punch In</span>
                    }
                    @if (parseJson(data.data).title === 'check_out') {
                    <span>Punch Out</span>
                    }
                    @if (parseJson(data.data).title === 'overtime') {
                    <span>Over Time</span>
                    }
                    on {{ formatOnlyDate(parseJson(data.data).date) }}.
                  </h4>
                </div>
              </div>
              @if ( data.req_notifications[0].is_read == 0) {
              <div class="active-section">
                <div class="div-cirlce">
                </div>
              </div>
              }
            </div>
            }
            @if (['Approved Attendance' ].includes(data.req_type) && showAdmintab) {
            <div class="notify-content-main content-display"
              [ngClass]="{ 'notify-active': data.req_notifications[0].is_read == 0 }"
              [routerLink]="['/user-attendance-list']"
              (click)="data.req_notifications[0].is_read == 0 && clearnotifications(data.req_notifications[0].notification_id)">
              <div class="notify-content-left">
                <img [src]="parseJson(data.data).sender_user.profile_image" alt="Profile Image" />
                <div class="action-circle">
                  <img src="../../../../assets/theme1/tick.png" alt="Profile Image" />
                </div>
              </div>
              <div class="notify-content-right">
                <!-- <h1>{{parseJson(data.data).title}}</h1> -->
                <h1>{{data.req_type}}</h1>
                <p>{{ formatDate(parseJson(data.data).date) }}</p>
                <div class="notify-inner-sec">
                  <h4>
                    <span>{{ parseJson(data.data).sender_user.first_name }} {{
                      parseJson(data.data).sender_user.last_name }}</span>
                    has {{ parseJson(data.data).title[0] }} request of {{ parseJson(data.data).title[1] }}
                    on {{ formatOnlyDate(parseJson(data.data).date) }}.
                  </h4>
                </div>
              </div>
            </div>
            }
            @if (['Approved Attendance' ].includes(data.req_type) && EmployeeTab ) {
            <div class="notify-content-main content-display"
              [ngClass]="{ 'notify-active': data.req_notifications[0].is_read == 0 }"
              [routerLink]="['/user-attendance']"
              (click)="data.req_notifications[0].is_read == 0 && clearnotifications(data.req_notifications[0].notification_id)">
              <div class="notify-content-left">
                <img [src]="parseJson(data.data).sender_user.profile_image" alt="Profile Image" />
              </div>
              <div class="notify-content-right">
                <!-- <h1>{{parseJson(data.data).title}}</h1> -->
                <h1>{{data.req_type}}</h1>
                <p>{{ formatDate(parseJson(data.data).date) }}</p>
                <div class="notify-inner-sec">
                  <h4>
                    <span>{{ parseJson(data.data).sender_user.first_name }} {{
                      parseJson(data.data).sender_user.last_name }}</span>
                    has {{ parseJson(data.data).title[0] }} request
                    on {{ formatOnlyDate(parseJson(data.data).date) }}.
                  </h4>
                </div>
              </div>
              @if ( data.req_notifications[0].is_read == 0) {
              <div class="active-section">
                <div class="div-cirlce">
                </div>
              </div>
              }
            </div>
            }
            @if (['Rejected Attendance' ].includes(data.req_type) && showAdmintab) {
            <div class="notify-content-main content-display"
              [ngClass]="{ 'notify-active': data.req_notifications[0].is_read == 0 }"
              [routerLink]="['/user-attendance-list']"
              (click)="data.req_notifications[0].is_read == 0 && clearnotifications(data.req_notifications[0].notification_id)">
              <div class="notify-content-left">
                <img [src]="parseJson(data.data).sender_user.profile_image" alt="Profile Image" />
                <div class="action-circle">
                  <img src="../../../../assets/theme1/coss.png" alt="Profile Image" />
                </div>
              </div>
              <div class="notify-content-right">
                <!-- <h1>{{parseJson(data.data).title}}</h1> -->
                <h1>{{data.req_type}}</h1>
                <p>{{ formatDate(parseJson(data.data).date) }}</p>
                <div class="notify-inner-sec">
                  <h4>
                    <span>{{ parseJson(data.data).sender_user.first_name }} {{
                      parseJson(data.data).sender_user.last_name }}</span>
                    has {{ parseJson(data.data).title[0] }} request of {{ parseJson(data.data).title[1] }}
                    on {{ formatOnlyDate(parseJson(data.data).date) }}.
                  </h4>
                </div>
              </div>
              @if ( data.req_notifications[0].is_read == 0) {
              <div class="active-section">
                <div class="div-cirlce">
                </div>
              </div>
              }
            </div>
            }
            @if (['Rejected Attendance' ].includes(data.req_type) && EmployeeTab ) {
            <div class="notify-content-main content-display"
              [ngClass]="{ 'notify-active': data.req_notifications[0].is_read == 0 }"
              [routerLink]="['/user-attendance']"
              (click)="data.req_notifications[0].is_read == 0 && clearnotifications(data.req_notifications[0].notification_id)">
              <div class="notify-content-left">
                <img [src]="parseJson(data.data).sender_user.profile_image" alt="Profile Image" />
                <div class="action-circle">
                  <img src="../../../../assets/theme1/coss.png" alt="Profile Image" />
                </div>
              </div>
              <div class="notify-content-right">
                <!-- <h1>{{parseJson(data.data).title}}</h1> -->
                <h1>{{data.req_type}}</h1>
                <p>{{ formatDate(parseJson(data.data).date) }}</p>
                <div class="notify-inner-sec">
                  <h4>
                    <span>{{ parseJson(data.data).sender_user.first_name }} {{
                      parseJson(data.data).sender_user.last_name }}</span>
                    has {{ parseJson(data.data).title[0] }} request
                    on {{ formatOnlyDate(parseJson(data.data).date) }}.
                  </h4>
                </div>
              </div>
              @if ( data.req_notifications[0].is_read == 0) {
              <div class="active-section">
                <div class="div-cirlce">
                </div>
              </div>
              }
            </div>
            }
            <!-- Loan -->
            @if (['Loan Request' ].includes(data.req_type)) {
            <div class="notify-content-main content-display"
              [ngClass]="{ 'notify-active': data.req_notifications[0].is_read == 0 }"
              (click)="data.req_notifications[0].is_read == 0 && clearnotifications(data.req_notifications[0].notification_id)">
              <div class="notify-content-left">
                <img [src]="parseJson(data.data).sender_user.profile_image" alt="Profile Image" />
              </div>
              <div class="notify-content-right">
                <!-- <h1>{{parseJson(data.data).title}}</h1> -->
                <h1>{{data.req_type}}</h1>
                <p>{{ formatDate(parseJson(data.data).date) }}</p>
                <div class="notify-inner-sec">
                  <h4>
                    <span>{{ parseJson(data.data).sender_user.first_name }} {{
                      parseJson(data.data).sender_user.last_name }}</span>
                    has request for
                    <span>{{parseJson(data.data).title}}</span>
                    /- Pkr loan on {{ formatOnlyDate(parseJson(data.data).date) }}.
                  </h4>
                </div>
              </div>
              @if ( data.req_notifications[0].is_read == 0) {
              <div class="active-section">
                <div class="div-cirlce">
                </div>
              </div>
              }
            </div>
            }
            @if (['Approved Loan'].includes(data.req_type) && showAdmintab) {
            <div class="notify-content-main content-display"
              [ngClass]="{ 'notify-active': data.req_notifications[0].is_read == 0 }"
              (click)="data.req_notifications[0].is_read == 0 && clearnotifications(data.req_notifications[0].notification_id)">
              <div class="notify-content-left">
                <img [src]="parseJson(data.data).sender_user.profile_image" alt="Profile Image" />
                <div class="action-circle">
                  <img src="../../../../assets/theme1/tick.png" alt="Profile Image" />
                </div>
              </div>
              <div class="notify-content-right">
                <!-- <h1>{{parseJson(data.data).title}}</h1> -->
                <h1>{{data.req_type}}</h1>
                <p>{{ formatDate(parseJson(data.data).date) }}</p>
                <div class="notify-inner-sec">
                  <h4>
                    <span>{{ parseJson(data.data).sender_user.first_name }} {{
                      parseJson(data.data).sender_user.last_name }}</span>
                    had <span>{{ parseJson(data.data).title[0] }}</span> of <span>{{
                      parseJson(data.data).title[1] }}</span> on {{ formatOnlyDate(parseJson(data.data).date)
                    }}.
                  </h4>
                </div>
              </div>
              @if ( data.req_notifications[0].is_read == 0) {
              <div class="active-section">
                <div class="div-cirlce">
                </div>
              </div>
              }
            </div>
            }
            @if (['Approved Loan'].includes(data.req_type) && EmployeeTab) {
            <div class="notify-content-main content-display"
              [ngClass]="{ 'notify-active': data.req_notifications[0].is_read == 0 }"
              (click)="data.req_notifications[0].is_read == 0 && clearnotifications(data.req_notifications[0].notification_id)">
              <div class="notify-content-left">
                <img [src]="parseJson(data.data).title[3] " alt="Profile Image" />
                <div class="action-circle">
                  <img src="../../../../assets/theme1/tick.png" alt="Profile Image" />
                </div>
              </div>
              <div class="notify-content-right">
                <!-- <h1>{{parseJson(data.data).title}}</h1> -->
                <h1>{{data.req_type}}</h1>
                <p>{{ formatDate(parseJson(data.data).date) }}</p>
                <div class="notify-inner-sec">
                  <h4>
                    <span>{{ parseJson(data.data).sender_user.first_name }} {{
                      parseJson(data.data).sender_user.last_name }}</span>
                    had <span>{{ parseJson(data.data).title[0] }}</span> on {{
                    formatOnlyDate(parseJson(data.data).date) }}.
                  </h4>
                </div>
              </div>
              @if ( data.req_notifications[0].is_read == 0) {
              <div class="active-section">
                <div class="div-cirlce">
                </div>
              </div>
              }
            </div>
            }
            @if (['Rejected Loan'].includes(data.req_type) && showAdmintab) {
            <div class="notify-content-main content-display"
              [ngClass]="{ 'notify-active': data.req_notifications[0].is_read == 0 }"
              (click)="data.req_notifications[0].is_read == 0 && clearnotifications(data.req_notifications[0].notification_id)">
              <div class="notify-content-left">
                <img [src]="parseJson(data.data).sender_user.profile_image" alt="Profile Image" />
                <div class="action-circle">
                  <img src="../../../../assets/theme1/coss.png" alt="Profile Image" />
                </div>
              </div>
              <div class="notify-content-right">
                <!-- <h1>{{parseJson(data.data).title}}</h1> -->
                <h1>{{data.req_type}}</h1>
                <p>{{ formatDate(parseJson(data.data).date) }}</p>
                <div class="notify-inner-sec">
                  <h4>
                    <span>{{ parseJson(data.data).sender_user.first_name }} {{
                      parseJson(data.data).sender_user.last_name }}</span>
                    had <span>{{ parseJson(data.data).title[0] }}</span> of <span>{{
                      parseJson(data.data).title[1] }}</span> on {{ formatOnlyDate(parseJson(data.data).date)
                    }}.
                  </h4>
                </div>
              </div>
              @if ( data.req_notifications[0].is_read == 0) {
              <div class="active-section">
                <div class="div-cirlce">
                </div>
              </div>
              }
            </div>
            }
            @if (['Rejected Loan'].includes(data.req_type) && EmployeeTab) {
            <div class="notify-content-main content-display"
              [ngClass]="{ 'notify-active': data.req_notifications[0].is_read == 0 }"
              (click)="data.req_notifications[0].is_read == 0 && clearnotifications(data.req_notifications[0].notification_id)">
              <div class="notify-content-left">
                <img [src]="parseJson(data.data).title[3] " alt="Profile Image" />
                <div class="action-circle">
                  <img src="../../../../assets/theme1/coss.png" alt="Profile Image" />
                </div>
              </div>
              <div class="notify-content-right">
                <!-- <h1>{{parseJson(data.data).title}}</h1> -->
                <h1>{{data.req_type}}</h1>
                <p>{{ formatDate(parseJson(data.data).date) }}</p>
                <div class="notify-inner-sec">
                  <h4>
                    <span>{{ parseJson(data.data).sender_user.first_name }} {{
                      parseJson(data.data).sender_user.last_name }}</span>
                    had <span>{{ parseJson(data.data).title[0] }}</span> on {{
                    formatOnlyDate(parseJson(data.data).date) }}.
                  </h4>
                </div>
              </div>
              @if ( data.req_notifications[0].is_read == 0) {
              <div class="active-section">
                <div class="div-cirlce">
                </div>
              </div>
              }
            </div>
            }
            @if (['Loan Request Edited' ].includes(data.req_type) ) {
            <div class="notify-content-main content-display"
              (click)="data.req_notifications[0].is_read == 0 && clearnotifications(data.req_notifications[0].notification_id)">
              <div class="notify-content-left">
                <img [src]="parseJson(data.data).sender_user.profile_image" alt="Profile Image" />
              </div>
              <div class="notify-content-right">
                <!-- <h1>{{parseJson(data.data).title}}</h1> -->
                <h1>{{data.req_type}}</h1>
                <p>{{ formatDate(parseJson(data.data).date) }}</p>
                <div class="notify-inner-sec">
                  <h4>
                    <span>{{ parseJson(data.data).sender_user.first_name }} {{
                      parseJson(data.data).sender_user.last_name }}</span>
                    has Edited Amount from
                    <span>{{ parseJson(data.data).title.split(',')[0] }}</span> to <span>{{
                      parseJson(data.data).title.split(',')[2] }}</span>
                    Duration from
                    <span>{{ parseJson(data.data).title.split(',')[1] }} Month</span> to <span>{{
                      parseJson(data.data).title.split(',')[3] }} Month</span>
                    on {{ formatOnlyDate(parseJson(data.data).date) }}.
                  </h4>
                </div>
              </div>
              @if ( data.req_notifications[0].is_read == 0) {
              <div class="active-section">
                <div class="div-cirlce">
                </div>
              </div>
              }
            </div>
            }
            @if (['Loan Request Deleted' ].includes(data.req_type)) {
            <div class="notify-content-main content-display"
              [ngClass]="{ 'notify-active': data.req_notifications[0].is_read == 0 }"
              (click)="data.req_notifications[0].is_read == 0 && clearnotifications(data.req_notifications[0].notification_id)">
              <div class="notify-content-left">
                <img [src]="parseJson(data.data).sender_user.profile_image" alt="Profile Image" />
              </div>
              <div class="notify-content-right">
                <!-- <h1>{{parseJson(data.data).title}}</h1> -->
                <h1>{{data.req_type}}</h1>
                <p>{{ formatDate(parseJson(data.data).date) }}</p>
                <div class="notify-inner-sec">
                  <h4>
                    <span>{{ parseJson(data.data).sender_user.first_name }} {{
                      parseJson(data.data).sender_user.last_name }}</span>
                    has Deleted Loan request
                    <span>{{ parseJson(data.data).title }}</span>
                    on {{ formatOnlyDate(parseJson(data.data).date) }}.
                  </h4>
                </div>
              </div>
              @if ( data.req_notifications[0].is_read == 0) {
              <div class="active-section">
                <div class="div-cirlce">
                </div>
              </div>
              }
            </div>
            }
            <!-- Policy -->
            @if (['Policy Added' ].includes(data.req_type)) {
            <div class="notify-content-main content-display"
              [ngClass]="{ 'notify-active': data.req_notifications[0].is_read == 0 }"
              (click)="data.req_notifications[0].is_read == 0 && clearnotifications(data.req_notifications[0].notification_id)">
              <div class="notify-content-left policy-image">
                <img src="../../../assets/theme1/policy.png" alt="Profile Image" />
              </div>
              <div class="notify-content-right">
                <!-- <h1>{{parseJson(data.data).title}}</h1> -->
                <h1>{{data.req_type}}</h1>
                <p>{{ formatDate(parseJson(data.data).date) }}</p>
                <div class="notify-inner-sec">
                  <h4>
                    <span>{{ parseJson(data.data).sender_user.first_name }} {{
                      parseJson(data.data).sender_user.last_name }}</span>
                    has Add New Policy
                    <span>{{ parseJson(data.data).title }}</span>
                    on {{ formatOnlyDate(parseJson(data.data).date) }}.
                  </h4>
                </div>
              </div>
            </div>
            }
            @if (['Policy Edit' ].includes(data.req_type)) {
            <div class="notify-content-main content-display"
              [ngClass]="{ 'notify-active': data.req_notifications[0].is_read == 0 }"
              (click)="data.req_notifications[0].is_read == 0 && clearnotifications(data.req_notifications[0].notification_id)">
              <div class="notify-content-left policy-image">
                <img src="../../../assets/theme1/policy.png" alt="Profile Image" />
              </div>
              <div class="notify-content-right">
                <!-- <h1>{{parseJson(data.data).title}}</h1> -->
                <h1>{{data.req_type}}</h1>
                <p>{{ formatDate(parseJson(data.data).date) }}</p>
                <div class="notify-inner-sec">
                  <h4>
                    <span>{{ parseJson(data.data).sender_user.first_name }} {{
                      parseJson(data.data).sender_user.last_name }}</span>
                    has Edit Policy
                    <span>{{ parseJson(data.data).title }}</span>
                    on {{ formatOnlyDate(parseJson(data.data).date) }}.
                  </h4>
                </div>
              </div>
            </div>
            }
            @if (['Policy Deleted' ].includes(data.req_type)) {
            <div class="notify-content-main content-display"
              [ngClass]="{ 'notify-active': data.req_notifications[0].is_read == 0 }"
              (click)="data.req_notifications[0].is_read == 0 && clearnotifications(data.req_notifications[0].notification_id)">
              <div class="notify-content-left policy-image">
                <img src="../../../assets/theme1/policy.png" alt="Profile Image" />
              </div>
              <div class="notify-content-right">
                <!-- <h1>{{parseJson(data.data).title}}</h1> -->
                <h1>{{data.req_type}}</h1>
                <p>{{ formatDate(parseJson(data.data).date) }}</p>
                <div class="notify-inner-sec">
                  <h4>
                    <span>{{ parseJson(data.data).sender_user.first_name }} {{
                      parseJson(data.data).sender_user.last_name }}</span>
                    has
                    <span>{{ parseJson(data.data).title }}</span>
                    on {{ formatOnlyDate(parseJson(data.data).date) }}.
                  </h4>
                </div>
              </div>
              @if ( data.req_notifications[0].is_read == 0) {
              <div class="active-section">
                <div class="div-cirlce">
                </div>
              </div>
              }
            </div>
            }
            <!-- evaluations -->
            @if (['Evaluation Added'].includes(data.req_type) && showAdmintab) {
            <div class="notify-content-main content-display"
              [ngClass]="{ 'notify-active': data.req_notifications[0].is_read == 0 }"
              (click)="data.req_notifications[0].is_read == 0 && clearnotifications(data.req_notifications[0].notification_id)">
              <div class="notify-content-left">
                <img [src]="parseJson(data.data).sender_user.profile_image" alt="Profile Image" />
              </div>
              <div class="notify-content-right">
                <!-- <h1>{{parseJson(data.data).title}}</h1> -->
                <h1>{{data.req_type}}</h1>
                <p>{{ formatDate(parseJson(data.data).date) }}</p>
                <div class="notify-inner-sec">
                  <h4>
                    <span>{{ parseJson(data.data).sender_user.first_name }} {{
                      parseJson(data.data).sender_user.last_name }}</span>
                    had <span>{{ parseJson(data.data).title[0] }}</span> of <span>{{
                      parseJson(data.data).title[1] }}</span> on {{ formatOnlyDate(parseJson(data.data).date)
                    }}.
                  </h4>
                </div>
              </div>
              @if ( data.req_notifications[0].is_read == 0) {
              <div class="active-section">
                <div class="div-cirlce">
                </div>
              </div>
              }
            </div>
            }
            @if (['Evaluation Added'].includes(data.req_type) && EmployeeTab) {
            <div class="notify-content-main content-display"
              [ngClass]="{ 'notify-active': data.req_notifications[0].is_read == 0 }"
              (click)="data.req_notifications[0].is_read == 0 && clearnotifications(data.req_notifications[0].notification_id)">
              <div class="notify-content-left">
                <img [src]="parseJson(data.data).title[3] " alt="Profile Image" />
              </div>
              <div class="notify-content-right">
                <!-- <h1>{{parseJson(data.data).title}}</h1> -->
                <h1>{{data.req_type}}</h1>
                <p>{{ formatDate(parseJson(data.data).date) }}</p>
                <div class="notify-inner-sec">
                  <h4>
                    <span>{{ parseJson(data.data).sender_user.first_name }} {{
                      parseJson(data.data).sender_user.last_name }}</span>
                    had <span>{{ parseJson(data.data).title[0] }}</span> on {{
                    formatOnlyDate(parseJson(data.data).date) }}.
                  </h4>
                </div>
              </div>
              @if ( data.req_notifications[0].is_read == 0) {
              <div class="active-section">
                <div class="div-cirlce">
                </div>
              </div>
              }
            </div>
            }

            <!-- payroll Admin-->


           @if (['Payroll Review Request'].includes(data.req_type) && showAdmintab) {
            <div class="notify-content-main content-display"
              [ngClass]="{ 'notify-active': data.req_notifications[0].is_read == 0 }"
              (click)="data.req_notifications[0].is_read == 0 && clearnotifications(data.req_notifications[0].notification_id)">
              <div class="notify-content-left">
                <img [src]="parseJson(data.data)?.sender_user?.profile_image" alt="Profile Image" />
              </div>
              <div class="notify-content-right">
                <!-- <h1>{{parseJson(data.data).title}}</h1> -->
                <h1>{{data.req_type}}</h1>
                <p>{{ formatDate(parseJson(data.data).date) }}</p>
                <div class="notify-inner-sec">
                  <h4>
                    <span>{{ parseJson(data.data).sender_user.first_name }} {{
                      parseJson(data.data).sender_user.last_name }}</span>
                    had send you <span>{{ parseJson(data.data).title }}</span> on {{
                    formatOnlyDate(parseJson(data.data).date) }}.
                  </h4>
                </div>
              </div>
              @if ( data.req_notifications[0].is_read == 0) {
              <div class="active-section">
                <div class="div-cirlce">
                </div>
              </div>
              }
            </div>
            }


          @if (['Payroll Change Requested'].includes(data.req_type) && showAdmintab) {
            <div class="notify-content-main content-display"
              [ngClass]="{ 'notify-active': data.req_notifications[0].is_read == 0 }"
              (click)="data.req_notifications[0].is_read == 0 && clearnotifications(data.req_notifications[0].notification_id)">
              <div class="notify-content-left">
                <img [src]="parseJson(data.data)?.sender_user?.profile_image" alt="Profile Image" />
              </div>
              <div class="notify-content-right">
                <!-- <h1>{{parseJson(data.data).title}}</h1> -->
                <h1>{{data.req_type}}</h1>
                <p>{{ formatDate(parseJson(data.data).date) }}</p>
                <div class="notify-inner-sec">
                  <h4>
                    <span>{{ parseJson(data.data).sender_user.first_name }} {{
                      parseJson(data.data).sender_user.last_name }}</span>
                    had send you <span>{{ parseJson(data.data).title }}</span> on {{
                    formatOnlyDate(parseJson(data.data).date) }}.
                  </h4>
                </div>
              </div>
              @if ( data.req_notifications[0].is_read == 0) {
              <div class="active-section">
                <div class="div-cirlce">
                </div>
              </div>
              }
            </div>
          }

           @if (['Payroll Approved'].includes(data.req_type) && showAdmintab) {
            <div class="notify-content-main content-display"
              [ngClass]="{ 'notify-active': data.req_notifications[0].is_read == 0 }"
              (click)="data.req_notifications[0].is_read == 0 && clearnotifications(data.req_notifications[0].notification_id)">
              <div class="notify-content-left">
                <img [src]="parseJson(data.data)?.sender_user?.profile_image" alt="Profile Image" />
              </div>
              <div class="notify-content-right">
                <!-- <h1>{{parseJson(data.data).title}}</h1> -->
                <h1>{{data.req_type}}</h1>
                <p>{{ formatDate(parseJson(data.data).date) }}</p>
                <div class="notify-inner-sec">
                  <h4>
                    <span>{{ parseJson(data.data).sender_user.first_name }} {{
                      parseJson(data.data).sender_user.last_name }}</span>
                    had just <span>{{ parseJson(data.data).title }}</span> on {{
                    formatOnlyDate(parseJson(data.data).date) }}.
                  </h4>
                </div>
              </div>
              @if ( data.req_notifications[0].is_read == 0) {
              <div class="active-section">
                <div class="div-cirlce">
                </div>
              </div>
              }
            </div>
          }
          

            }
          </div>
          <div class="notify-dropdown-footer" [routerLink]="['/notifications']">
            <p>View all notification <span>
                <img src="../../../../assets/images/arrow-black.svg" alt="Missing icon" />
              </span>
            </p>
          </div>
        </div>
        }
      </div>
      <div class="date-section">
        <img src="../../../../assets/theme1/date-icon.png" alt="icon missing" />
        <p>{{formattedDate}}</p>
      </div>
      <div class="user-profile-section" (click)="toggleDropdown()">
        <img [src]="user.profile_image || '../../../../assets/images/question.jpg'" alt="image missing" />
        <div class="user-detail-section">
          <p>{{ user.first_name}} {{user.last_name}}</p>
          <span>{{user.department}}</span>
        </div>
        <svg class="drop-icon" width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 1L7 7L13 1" stroke="#555555" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M1 1L7 7L13 1" stroke="black" stroke-opacity="0.2" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
        @if (isDropdownVisible) {
        <div class="drop-down-section">
          <ul>
            <!-- <li>
          <a href="#">
            <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1.25 14C3.00184 12.1419 5.38026 11 8 11C10.6197 11 12.9982 12.1419 14.75 14M11.375 4.625C11.375 6.48896 9.86396 8 8 8C6.13604 8 4.625 6.48896 4.625 4.625C4.625 2.76104 6.13604 1.25 8 1.25C9.86396 1.25 11.375 2.76104 11.375 4.625Z" stroke="#555555" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          Profile</a>
        </li> -->
            <li (click)="toggleSubList($event)">
              <!-- <a (click)="$event.preventDefault()" [routerLink]="['/theme']"> -->
              <a (click)="$event.preventDefault()">
                <div class="svg-icon">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M1.25 4.85C1.25 3.58988 1.25 2.95982 1.49524 2.47852C1.71095 2.05516 2.05516 1.71095 2.47852 1.49524C2.95982 1.25 3.58988 1.25 4.85 1.25H11.15C12.4101 1.25 13.0402 1.25 13.5215 1.49524C13.9448 1.71095 14.289 2.05516 14.5048 2.47852C14.75 2.95982 14.75 3.58988 14.75 4.85V11.15C14.75 12.4101 14.75 13.0402 14.5048 13.5215C14.289 13.9448 13.9448 14.289 13.5215 14.5048C13.0402 14.75 12.4101 14.75 11.15 14.75H4.85C3.58988 14.75 2.95982 14.75 2.47852 14.5048C2.05516 14.289 1.71095 13.9448 1.49524 13.5215C1.25 13.0402 1.25 12.4101 1.25 11.15V4.85Z"
                      stroke="#555555" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M5.75 6.125L3.5 10.25H12.5L9.125 4.625L7.25 7.25L5.75 6.125Z" stroke="#555555"
                      stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </div>
                <p>Theme</p>
              </a> <a class="sizeVersion"> version.1.1</a>
            </li>
            @if (showSubList) {
            <ul class="sub-list">
              <li (click)="sendValue(1)"><a>
                  <div class="svg-icon">
                    <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M8.60656 9.04948L6.73102 7.19346C6.31273 7.43909 5.90346 7.72819 5.45472 7.92751C5.13903 8.06811 4.77261 8.11554 4.42309 8.15337C4.0499 8.19346 3.73252 8.03141 3.46475 7.7632C2.56277 6.85524 1.67207 5.93881 0.751498 5.05287C0.273452 4.59211 0.183256 4.06359 0.319116 3.45772C0.468505 2.78917 0.832678 2.23412 1.32087 1.66213C1.01194 1.37076 0.706964 1.08449 0.403111 0.796513C0.30784 0.706168 0.219898 0.607919 0.121245 0.518139C-0.0163062 0.388834 -0.0568945 0.235813 0.079529 0.0991671C0.215952 -0.0374789 0.382818 -0.00981137 0.523751 0.131352C0.861991 0.470143 1.20023 0.808935 1.53847 1.14773C1.57793 1.18725 1.61965 1.22508 1.68448 1.28663C1.78595 1.20702 1.88573 1.1274 1.98664 1.05004C2.494 0.662126 3.04251 0.366812 3.68235 0.274774C4.16378 0.204757 4.58939 0.310347 4.94455 0.670031C5.87696 1.61112 6.8137 2.54882 7.75476 3.48313C8.177 3.9038 8.20575 4.41311 8.093 4.95123C7.94699 5.62881 7.5676 6.18838 7.14536 6.70165L9.02711 8.57178L10.8953 6.65478C10.6552 6.22904 10.3468 5.77731 10.141 5.28268C10.0098 4.94277 9.95686 4.57761 9.98601 4.21436C10.0151 3.93608 10.1338 3.67485 10.3243 3.47014C11.2741 2.47974 12.2477 1.51193 13.2264 0.550324C13.6565 0.127964 14.1886 0.145468 14.731 0.283244C15.3652 0.444734 15.8922 0.798206 16.4109 1.23751L17.4482 0.209839C17.4814 0.177089 17.509 0.138692 17.5445 0.107637C17.6832 -0.0143285 17.8585 -0.0510309 17.9595 0.107637C18.0158 0.198546 18.004 0.413679 17.933 0.496118C17.6635 0.808371 17.3596 1.09126 17.0648 1.38093C16.9929 1.44653 16.9176 1.50834 16.8393 1.56613C17.1246 2.05569 17.4171 2.48257 17.6285 2.94727C17.7644 3.24598 17.8151 3.59663 17.8394 3.92921C17.8659 4.29567 17.7216 4.62147 17.4504 4.88912C16.5028 5.82926 15.563 6.77732 14.6199 7.72198C14.1441 8.19798 13.5742 8.16693 12.9913 8.00769C12.3824 7.84112 11.8728 7.49104 11.4078 7.09521L9.43468 9.0715C10.2047 9.8383 10.9917 10.6192 11.7759 11.4035C13.2314 12.8599 14.6862 14.3171 16.1403 15.7751C16.1933 15.8281 16.2463 15.8818 16.2981 15.936C16.4312 16.0749 16.4436 16.2251 16.2981 16.3561C16.1651 16.478 16.0225 16.4487 15.8984 16.3239L14.6509 15.0709L9.20863 9.62316C9.15563 9.57065 9.10039 9.5204 8.99328 9.41876C8.86306 9.5667 8.74185 9.71972 8.60487 9.8575C6.49425 11.9727 4.38232 14.0869 2.26907 16.2002L2.16985 16.3002C2.03343 16.438 1.87897 16.4944 1.72845 16.3403C1.57793 16.1861 1.64333 16.0331 1.77919 15.8976C2.31135 15.3668 2.84295 14.8357 3.37399 14.3041L8.4521 9.22226C8.50452 9.16918 8.55131 9.11159 8.60656 9.04948ZM16.3088 5.22452C14.4959 4.69375 13.3476 3.54298 12.8306 1.72367C12.1383 2.41876 11.4669 3.09973 10.7865 3.77223C10.5503 4.00543 10.4821 4.27477 10.5278 4.59267C10.707 5.84564 12.1423 7.33067 13.3774 7.52153C13.6446 7.56331 13.9412 7.59776 14.1554 7.38545C14.877 6.67568 15.5861 5.95179 16.3088 5.22452ZM1.80455 5.28098C1.86092 5.34423 1.92124 5.41255 1.98438 5.47579C2.57461 6.06811 3.18232 6.64462 3.75 7.25783C4.07245 7.60566 4.44339 7.67737 4.84759 7.55032C6.19209 7.12571 7.08279 6.21661 7.53547 4.88799C7.68035 4.46167 7.59804 4.07489 7.23838 3.73835C6.61489 3.15676 6.02579 2.53564 5.42147 1.9309C5.37206 1.88667 5.32011 1.84538 5.26588 1.80724C4.75231 3.60848 3.60793 4.74174 1.80455 5.28324V5.28098ZM1.70816 2.06811C1.25717 2.62034 0.905398 3.14603 0.83324 3.81232C0.765028 4.44304 1.11849 4.77223 1.74649 4.67568C2.32206 4.5859 2.80743 4.30978 3.24545 3.94671C3.92193 3.38206 4.46199 2.71746 4.65873 1.83096C4.80587 1.16805 4.45353 0.741177 3.81313 0.820228C3.14906 0.902103 2.60675 1.24428 2.07853 1.71012C2.31812 1.93993 2.5391 2.15563 2.76516 2.36625C2.92075 2.5108 2.96697 2.67906 2.81138 2.83096C2.65579 2.98285 2.50302 2.90719 2.37111 2.76546C2.15858 2.54185 1.94436 2.31938 1.70816 2.07037V2.06811ZM16.0676 1.68245C15.5382 1.23073 15.0495 0.913396 14.4497 0.795948C13.6852 0.64688 13.2867 1.05004 13.4609 1.81232C13.6627 2.69883 14.2118 3.35552 14.8922 3.9134C15.3398 4.28042 15.8381 4.55541 16.4267 4.62881C16.9656 4.696 17.3236 4.39335 17.2875 3.86032C17.2384 3.14773 16.8839 2.5746 16.3945 2.01955C16.1662 2.25953 15.9582 2.47523 15.753 2.69375C15.6171 2.8383 15.461 2.9309 15.2941 2.76489C15.1273 2.59888 15.2051 2.43852 15.3556 2.3047C15.5856 2.10255 15.8184 1.90154 16.0676 1.68471V1.68245Z"
                        fill="#555555" stroke="#555555" stroke-width="0.5" />
                    </svg>
                  </div>
                  <p>Marshmallow</p>
                </a></li>
              <li (click)="sendValue(2)"><a>
                  <div class="svg-icon">
                    <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <mask id="path-1-inside-1_3967_3022" fill="white">
                        <path
                          d="M12.5617 0.836914C11.4156 1.57906 9.67183 2.17848 9.40113 3.4993C8.66285 2.67137 7.54136 2.1957 6.69058 2.18164C5.44605 2.1725 4.18394 2.55852 3.02378 3.27676C5.17183 3.41914 6.13511 3.7373 7.9105 4.2998L7.1441 4.6373C6.66246 4.84824 6.45152 5.05566 6.3566 5.23144C6.14566 5.89238 6.51128 6.41621 6.44097 7.02441C6.88042 6.91191 7.32339 6.84512 7.71011 6.72207C8.28668 6.53574 8.72964 6.26504 9.00738 5.47402L9.24292 4.79902L9.58394 5.4248C9.99878 6.18769 10.375 6.53926 10.7125 6.70449C11.05 6.86621 11.3839 6.85918 11.7812 6.80293C12.4843 6.71152 13.0011 6.56387 13.6339 6.73965C13.3703 6.10684 13.314 5.62871 13.1277 5.30527C12.4527 4.42637 10.8918 4.13809 10.0023 3.93769C10.1078 2.45621 11.964 2.00797 12.9203 1.35723L12.5617 0.836914ZM1.8566 3.92012C1.13624 4.98535 1.71949 6.08926 2.8691 5.8959C2.80582 5.12246 3.073 4.40176 3.62847 3.92363C3.14683 3.81113 2.20816 3.54043 1.8566 3.92012ZM4.85542 4.07832C4.33511 4.19434 3.81128 4.45098 3.58628 5.05566C3.298 5.81855 3.62144 6.60605 4.25777 6.84512C4.65152 6.99277 5.4355 6.85918 5.78355 6.58848C5.87847 5.88887 5.52339 5.27715 5.91363 4.75684C5.70269 4.39121 5.27027 3.99394 4.85542 4.07832ZM1.12816 5.8748C0.969956 6.02949 0.836362 6.22637 0.748472 6.46191C0.46019 7.2248 0.783628 8.0123 1.41996 8.25137C1.63863 8.33574 1.87417 8.34277 2.10269 8.28652C2.05347 7.59746 2.24332 6.98574 2.67925 6.51113C2.03589 6.49004 1.50785 6.34238 1.12816 5.8748ZM9.16207 6.48301C8.8105 6.92246 8.35699 7.17559 7.90347 7.32324C7.42535 7.47793 6.94371 7.55176 6.53238 7.65723C6.6941 7.81543 6.89449 7.94551 7.12652 8.0334C7.95269 8.34277 8.82808 7.97363 9.10582 7.23887C9.19722 6.99277 9.2148 6.73262 9.16207 6.48301ZM3.22417 6.81348C3.03785 6.97519 2.88316 7.19316 2.78472 7.45332C2.49996 8.21973 2.81988 9.00723 3.45621 9.24629C3.79019 9.36933 4.15582 9.32363 4.47222 9.14434C4.16988 8.51504 4.86246 7.61504 5.19996 7.49199C4.39839 7.46387 3.71988 7.48496 3.22417 6.81348ZM9.823 6.83105C9.80191 7.27402 9.63667 7.68535 9.38355 8.00527C9.4398 8.49043 9.72457 8.90176 10.1535 9.06348C10.7863 9.30254 11.5492 8.92285 11.8375 8.15644C11.9324 7.90684 11.9605 7.65371 11.9324 7.41816C11.0148 7.46738 10.4382 7.42871 9.823 6.83105ZM12.5546 7.32324C12.625 8.14941 12.2839 8.92988 11.6617 9.39394C11.8867 9.77012 12.2418 10.0338 12.6214 10.0795C13.2753 10.1639 13.8449 9.60137 13.8484 8.75762C13.8484 8.11777 13.525 7.55879 13.082 7.28809C12.9027 7.28105 12.7093 7.29863 12.5546 7.32324ZM5.89957 7.88926C5.5023 8.02637 5.323 8.16348 5.17886 8.53613C4.90464 9.26035 5.35816 10.1393 6.25464 10.4803C7.15113 10.8178 8.07222 10.4521 8.34293 9.72441C8.46949 9.39394 8.44136 9.02832 8.29019 8.70137C7.33746 8.87715 6.47261 8.60644 5.89957 7.88926ZM0.565659 8.43418C0.410972 8.63105 0.301987 8.88066 0.2598 9.17246C0.142729 9.9916 0.618394 10.7404 1.2723 10.8881C1.37988 10.9127 1.49062 10.9162 1.59996 10.9057C1.40519 10.2412 1.51523 9.47832 1.88824 8.95449C1.38023 8.96855 0.895776 8.76465 0.565659 8.43418ZM9.00738 8.85605C9.09527 9.47129 9.02144 9.95996 8.67691 10.4205C8.81753 10.7826 9.09878 11.0604 9.46089 11.1623C10.1148 11.3451 10.8425 10.9021 11.0605 10.1146C11.1027 9.97051 11.1238 9.82285 11.1238 9.67168C10.2378 9.90019 9.4398 9.59785 9.00738 8.85605ZM2.48589 9.2498C2.28199 9.47832 2.14839 9.79473 2.1273 10.1674C2.0816 10.9936 2.61949 11.6967 3.28394 11.7846C3.55816 11.8232 3.82183 11.7494 4.04332 11.5947C4.04332 11.0428 4.24371 10.526 4.58472 10.1463C4.57066 10.0373 4.54253 9.92832 4.50738 9.82285C3.69878 10.0514 2.97105 9.88262 2.48589 9.2498ZM11.6371 10.2693C11.4507 10.9303 11.1625 11.2361 10.7406 11.5104C10.8636 11.8338 11.1062 12.0939 11.4261 12.2135C12.0589 12.4525 12.8218 12.0729 13.1101 11.31C13.191 11.0955 13.2226 10.8846 13.2156 10.6807C12.6531 10.8178 12.0343 10.5998 11.6371 10.2693ZM5.12964 10.4908C4.97496 10.6385 4.84839 10.8248 4.76753 11.0393C4.48277 11.7881 4.85191 12.6107 5.58316 12.885C6.31792 13.1627 7.13355 12.7865 7.41832 12.0377C7.52378 11.7494 7.53785 11.4506 7.47105 11.1764C6.55699 11.3135 5.75191 11.1025 5.12964 10.4908ZM8.24097 10.9619C8.18824 10.976 8.13199 10.9936 8.07925 11.0146C8.248 11.9076 7.94566 12.7373 7.2566 13.2295C7.34097 13.3385 7.44996 13.4264 7.56949 13.4932C8.16011 13.8131 9.01089 13.5635 9.46089 12.8709C9.68941 12.5229 9.75972 12.1432 9.69996 11.8127C9.10581 11.7951 8.51519 11.3943 8.24097 10.9619ZM0.282651 11.0111C0.200034 11.1975 0.152573 11.4154 0.152222 11.658C0.152222 12.4244 0.618393 13.0783 1.19496 13.2541C1.03429 12.6529 1.05222 12.0623 1.31449 11.5385C0.926362 11.4682 0.525229 11.2467 0.282651 11.0111ZM1.99019 11.6615C1.8566 11.8479 1.76519 12.0799 1.72652 12.3436C1.60699 13.1627 2.08511 13.9115 2.73902 14.0557C2.90425 14.0943 3.07652 14.0908 3.24175 14.0451C3.14332 13.4369 3.20308 12.9201 3.49136 12.4314C2.91832 12.4314 2.2855 12.0342 1.99019 11.6615ZM10.3679 12.1467C10.28 12.8604 9.94957 13.4229 9.40464 13.8131C9.49957 13.9748 9.63667 14.1084 9.80894 14.2033C10.396 14.5268 11.2468 14.2771 11.7003 13.5846C11.841 13.3631 11.9218 13.1346 11.95 12.9131C11.3171 12.9482 10.6984 12.6213 10.3679 12.1467ZM4.25074 12.4631C4.08199 12.6389 3.95191 12.8639 3.87808 13.1275C3.6566 13.908 4.06089 14.6744 4.73941 14.8643C5.41792 15.0541 6.15621 14.6076 6.37769 13.8236C6.39878 13.7428 6.41285 13.6619 6.42339 13.5775C5.34058 13.792 4.64097 13.233 4.25074 12.4631ZM7.01402 13.8869C6.88394 14.3896 6.50074 14.9381 6.13863 15.1912C6.22652 15.3002 6.33199 15.3881 6.45503 15.4549C7.04566 15.7748 7.89292 15.5287 8.34644 14.8326C8.48355 14.6217 8.56441 14.4002 8.59253 14.1822C7.95972 14.2596 7.47105 14.2244 7.01402 13.8869ZM1.53667 13.9326C1.50011 14.1049 1.49238 14.1682 1.48675 14.2877C1.46566 14.7096 1.58238 15.0998 1.76519 15.3775C1.95152 15.6518 2.19058 15.81 2.45074 15.8346C2.52808 15.4232 2.59488 15.026 2.77066 14.7061C2.21871 14.5443 1.82496 14.3686 1.53667 13.9326ZM9.17613 14.5408C9.00738 15.1139 8.57847 15.6096 8.10738 15.8908C8.11792 15.8979 8.12496 15.9049 8.1355 15.9084C8.68042 16.2775 9.57339 16.1193 10.1289 15.483C10.28 15.3143 10.382 15.1314 10.4453 14.9521C9.93199 14.9381 9.53472 14.8396 9.17613 14.5408ZM3.53355 14.7131C3.40347 14.8643 3.29097 15.0471 3.21011 15.2615C2.9148 16.042 3.19957 16.7979 3.73394 16.9982C4.26832 17.1986 4.97847 16.8154 5.27027 16.0385C5.33707 15.8557 5.37574 15.6799 5.38628 15.5076C4.63746 15.6236 3.92027 15.2826 3.53355 14.7131ZM5.96636 15.8979C5.88902 16.274 5.69917 16.6502 5.48472 16.9244C5.51285 16.9561 5.548 16.9877 5.58316 17.0123C5.7941 17.167 6.07886 17.2057 6.39878 17.1178C6.95425 16.9033 7.31285 16.6115 7.55542 16.1264C6.94371 16.2143 6.41285 16.2037 5.96636 15.8979Z" />
                      </mask>
                      <path
                        d="M12.5617 0.836914C11.4156 1.57906 9.67183 2.17848 9.40113 3.4993C8.66285 2.67137 7.54136 2.1957 6.69058 2.18164C5.44605 2.1725 4.18394 2.55852 3.02378 3.27676C5.17183 3.41914 6.13511 3.7373 7.9105 4.2998L7.1441 4.6373C6.66246 4.84824 6.45152 5.05566 6.3566 5.23144C6.14566 5.89238 6.51128 6.41621 6.44097 7.02441C6.88042 6.91191 7.32339 6.84512 7.71011 6.72207C8.28668 6.53574 8.72964 6.26504 9.00738 5.47402L9.24292 4.79902L9.58394 5.4248C9.99878 6.18769 10.375 6.53926 10.7125 6.70449C11.05 6.86621 11.3839 6.85918 11.7812 6.80293C12.4843 6.71152 13.0011 6.56387 13.6339 6.73965C13.3703 6.10684 13.314 5.62871 13.1277 5.30527C12.4527 4.42637 10.8918 4.13809 10.0023 3.93769C10.1078 2.45621 11.964 2.00797 12.9203 1.35723L12.5617 0.836914ZM1.8566 3.92012C1.13624 4.98535 1.71949 6.08926 2.8691 5.8959C2.80582 5.12246 3.073 4.40176 3.62847 3.92363C3.14683 3.81113 2.20816 3.54043 1.8566 3.92012ZM4.85542 4.07832C4.33511 4.19434 3.81128 4.45098 3.58628 5.05566C3.298 5.81855 3.62144 6.60605 4.25777 6.84512C4.65152 6.99277 5.4355 6.85918 5.78355 6.58848C5.87847 5.88887 5.52339 5.27715 5.91363 4.75684C5.70269 4.39121 5.27027 3.99394 4.85542 4.07832ZM1.12816 5.8748C0.969956 6.02949 0.836362 6.22637 0.748472 6.46191C0.46019 7.2248 0.783628 8.0123 1.41996 8.25137C1.63863 8.33574 1.87417 8.34277 2.10269 8.28652C2.05347 7.59746 2.24332 6.98574 2.67925 6.51113C2.03589 6.49004 1.50785 6.34238 1.12816 5.8748ZM9.16207 6.48301C8.8105 6.92246 8.35699 7.17559 7.90347 7.32324C7.42535 7.47793 6.94371 7.55176 6.53238 7.65723C6.6941 7.81543 6.89449 7.94551 7.12652 8.0334C7.95269 8.34277 8.82808 7.97363 9.10582 7.23887C9.19722 6.99277 9.2148 6.73262 9.16207 6.48301ZM3.22417 6.81348C3.03785 6.97519 2.88316 7.19316 2.78472 7.45332C2.49996 8.21973 2.81988 9.00723 3.45621 9.24629C3.79019 9.36933 4.15582 9.32363 4.47222 9.14434C4.16988 8.51504 4.86246 7.61504 5.19996 7.49199C4.39839 7.46387 3.71988 7.48496 3.22417 6.81348ZM9.823 6.83105C9.80191 7.27402 9.63667 7.68535 9.38355 8.00527C9.4398 8.49043 9.72457 8.90176 10.1535 9.06348C10.7863 9.30254 11.5492 8.92285 11.8375 8.15644C11.9324 7.90684 11.9605 7.65371 11.9324 7.41816C11.0148 7.46738 10.4382 7.42871 9.823 6.83105ZM12.5546 7.32324C12.625 8.14941 12.2839 8.92988 11.6617 9.39394C11.8867 9.77012 12.2418 10.0338 12.6214 10.0795C13.2753 10.1639 13.8449 9.60137 13.8484 8.75762C13.8484 8.11777 13.525 7.55879 13.082 7.28809C12.9027 7.28105 12.7093 7.29863 12.5546 7.32324ZM5.89957 7.88926C5.5023 8.02637 5.323 8.16348 5.17886 8.53613C4.90464 9.26035 5.35816 10.1393 6.25464 10.4803C7.15113 10.8178 8.07222 10.4521 8.34293 9.72441C8.46949 9.39394 8.44136 9.02832 8.29019 8.70137C7.33746 8.87715 6.47261 8.60644 5.89957 7.88926ZM0.565659 8.43418C0.410972 8.63105 0.301987 8.88066 0.2598 9.17246C0.142729 9.9916 0.618394 10.7404 1.2723 10.8881C1.37988 10.9127 1.49062 10.9162 1.59996 10.9057C1.40519 10.2412 1.51523 9.47832 1.88824 8.95449C1.38023 8.96855 0.895776 8.76465 0.565659 8.43418ZM9.00738 8.85605C9.09527 9.47129 9.02144 9.95996 8.67691 10.4205C8.81753 10.7826 9.09878 11.0604 9.46089 11.1623C10.1148 11.3451 10.8425 10.9021 11.0605 10.1146C11.1027 9.97051 11.1238 9.82285 11.1238 9.67168C10.2378 9.90019 9.4398 9.59785 9.00738 8.85605ZM2.48589 9.2498C2.28199 9.47832 2.14839 9.79473 2.1273 10.1674C2.0816 10.9936 2.61949 11.6967 3.28394 11.7846C3.55816 11.8232 3.82183 11.7494 4.04332 11.5947C4.04332 11.0428 4.24371 10.526 4.58472 10.1463C4.57066 10.0373 4.54253 9.92832 4.50738 9.82285C3.69878 10.0514 2.97105 9.88262 2.48589 9.2498ZM11.6371 10.2693C11.4507 10.9303 11.1625 11.2361 10.7406 11.5104C10.8636 11.8338 11.1062 12.0939 11.4261 12.2135C12.0589 12.4525 12.8218 12.0729 13.1101 11.31C13.191 11.0955 13.2226 10.8846 13.2156 10.6807C12.6531 10.8178 12.0343 10.5998 11.6371 10.2693ZM5.12964 10.4908C4.97496 10.6385 4.84839 10.8248 4.76753 11.0393C4.48277 11.7881 4.85191 12.6107 5.58316 12.885C6.31792 13.1627 7.13355 12.7865 7.41832 12.0377C7.52378 11.7494 7.53785 11.4506 7.47105 11.1764C6.55699 11.3135 5.75191 11.1025 5.12964 10.4908ZM8.24097 10.9619C8.18824 10.976 8.13199 10.9936 8.07925 11.0146C8.248 11.9076 7.94566 12.7373 7.2566 13.2295C7.34097 13.3385 7.44996 13.4264 7.56949 13.4932C8.16011 13.8131 9.01089 13.5635 9.46089 12.8709C9.68941 12.5229 9.75972 12.1432 9.69996 11.8127C9.10581 11.7951 8.51519 11.3943 8.24097 10.9619ZM0.282651 11.0111C0.200034 11.1975 0.152573 11.4154 0.152222 11.658C0.152222 12.4244 0.618393 13.0783 1.19496 13.2541C1.03429 12.6529 1.05222 12.0623 1.31449 11.5385C0.926362 11.4682 0.525229 11.2467 0.282651 11.0111ZM1.99019 11.6615C1.8566 11.8479 1.76519 12.0799 1.72652 12.3436C1.60699 13.1627 2.08511 13.9115 2.73902 14.0557C2.90425 14.0943 3.07652 14.0908 3.24175 14.0451C3.14332 13.4369 3.20308 12.9201 3.49136 12.4314C2.91832 12.4314 2.2855 12.0342 1.99019 11.6615ZM10.3679 12.1467C10.28 12.8604 9.94957 13.4229 9.40464 13.8131C9.49957 13.9748 9.63667 14.1084 9.80894 14.2033C10.396 14.5268 11.2468 14.2771 11.7003 13.5846C11.841 13.3631 11.9218 13.1346 11.95 12.9131C11.3171 12.9482 10.6984 12.6213 10.3679 12.1467ZM4.25074 12.4631C4.08199 12.6389 3.95191 12.8639 3.87808 13.1275C3.6566 13.908 4.06089 14.6744 4.73941 14.8643C5.41792 15.0541 6.15621 14.6076 6.37769 13.8236C6.39878 13.7428 6.41285 13.6619 6.42339 13.5775C5.34058 13.792 4.64097 13.233 4.25074 12.4631ZM7.01402 13.8869C6.88394 14.3896 6.50074 14.9381 6.13863 15.1912C6.22652 15.3002 6.33199 15.3881 6.45503 15.4549C7.04566 15.7748 7.89292 15.5287 8.34644 14.8326C8.48355 14.6217 8.56441 14.4002 8.59253 14.1822C7.95972 14.2596 7.47105 14.2244 7.01402 13.8869ZM1.53667 13.9326C1.50011 14.1049 1.49238 14.1682 1.48675 14.2877C1.46566 14.7096 1.58238 15.0998 1.76519 15.3775C1.95152 15.6518 2.19058 15.81 2.45074 15.8346C2.52808 15.4232 2.59488 15.026 2.77066 14.7061C2.21871 14.5443 1.82496 14.3686 1.53667 13.9326ZM9.17613 14.5408C9.00738 15.1139 8.57847 15.6096 8.10738 15.8908C8.11792 15.8979 8.12496 15.9049 8.1355 15.9084C8.68042 16.2775 9.57339 16.1193 10.1289 15.483C10.28 15.3143 10.382 15.1314 10.4453 14.9521C9.93199 14.9381 9.53472 14.8396 9.17613 14.5408ZM3.53355 14.7131C3.40347 14.8643 3.29097 15.0471 3.21011 15.2615C2.9148 16.042 3.19957 16.7979 3.73394 16.9982C4.26832 17.1986 4.97847 16.8154 5.27027 16.0385C5.33707 15.8557 5.37574 15.6799 5.38628 15.5076C4.63746 15.6236 3.92027 15.2826 3.53355 14.7131ZM5.96636 15.8979C5.88902 16.274 5.69917 16.6502 5.48472 16.9244C5.51285 16.9561 5.548 16.9877 5.58316 17.0123C5.7941 17.167 6.07886 17.2057 6.39878 17.1178C6.95425 16.9033 7.31285 16.6115 7.55542 16.1264C6.94371 16.2143 6.41285 16.2037 5.96636 15.8979Z"
                        stroke="#555555" stroke-width="2" mask="url(#path-1-inside-1_3967_3022)" />
                    </svg>
                  </div>
                  <p>BlackBerry</p>
                </a></li>
            </ul>
            }
            <li>
              <a [routerLink]="['/update-password']">
                <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M10.75 6.5V5C10.75 2.92893 9.07107 1.25 7 1.25C4.92893 1.25 3.25 2.92893 3.25 5V6.5M7 9.875V11.375M4.6 14.75H9.4C10.6601 14.75 11.2902 14.75 11.7715 14.5048C12.1948 14.289 12.539 13.9448 12.7548 13.5215C13 13.0402 13 12.4101 13 11.15V10.1C13 8.83988 13 8.20982 12.7548 7.72852C12.539 7.30516 12.1948 6.96095 11.7715 6.74524C11.2902 6.5 10.6601 6.5 9.4 6.5H4.6C3.33988 6.5 2.70982 6.5 2.22852 6.74524C1.80516 6.96095 1.46095 7.30516 1.24524 7.72852C1 8.20982 1 8.83988 1 10.1V11.15C1 12.4101 1 13.0402 1.24524 13.5215C1.46095 13.9448 1.80516 14.289 2.22852 14.5048C2.70982 14.75 3.33988 14.75 4.6 14.75Z"
                    stroke="#555555" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                Update Password</a>
            </li>
            <li>
              <a (click)=showUserDetails(user)>
                <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M0.697904 6.28488C0.595764 6.12315 0.544694 6.04229 0.516105 5.91756C0.494632 5.82387 0.494632 5.67613 0.516105 5.58244C0.544694 5.45771 0.595764 5.37685 0.697904 5.21512C1.54196 3.87863 4.05436 0.5 7.88312 0.5C11.7119 0.5 14.2243 3.87863 15.0683 5.21512C15.1705 5.37685 15.2215 5.45771 15.2501 5.58244C15.2716 5.67613 15.2716 5.82387 15.2501 5.91756C15.2215 6.04229 15.1705 6.12315 15.0683 6.28488C14.2243 7.62137 11.7119 11 7.88312 11C4.05436 11 1.54196 7.62137 0.697904 6.28488Z"
                    stroke="#555555" stroke-linecap="round" stroke-linejoin="round" />
                  <path
                    d="M7.88312 8C9.12576 8 10.1331 6.99264 10.1331 5.75C10.1331 4.50736 9.12576 3.5 7.88312 3.5C6.64047 3.5 5.63312 4.50736 5.63312 5.75C5.63312 6.99264 6.64047 8 7.88312 8Z"
                    stroke="#555555" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                Profile View</a>
            </li>

            <li>
              <a (click)=resetUserAuth()>

                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M1.5 10.5C1.5 10.5 1.59099 11.1369 4.22703 13.773C6.86307 16.409 11.1369 16.409 13.773 13.773C14.7069 12.839 15.31 11.6995 15.5821 10.5M1.5 10.5V15M1.5 10.5H6M16.5 7.5C16.5 7.5 16.409 6.86307 13.773 4.22703C11.1369 1.59099 6.86307 1.59099 4.22703 4.22703C3.29307 5.16098 2.69002 6.30054 2.41787 7.5M16.5 7.5V3M16.5 7.5H12"
                    stroke="#555555" stroke-linecap="round" stroke-linejoin="round" />
                </svg>

                Reset Authentication</a>
            </li>

            <li>

              <a [routerLink]="['/apply-resignation']">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M11 11.75L14.75 8M14.75 8L11 4.25M14.75 8H5.75M8 11.75C8 12.4475 8 12.7962 7.92333 13.0823C7.71528 13.8588 7.1088 14.4653 6.33234 14.6733C6.04622 14.75 5.69748 14.75 5 14.75H4.625C3.57663 14.75 3.05245 14.75 2.63896 14.5787C2.08765 14.3504 1.64963 13.9124 1.42127 13.361C1.25 12.9476 1.25 12.4234 1.25 11.375V4.625C1.25 3.57663 1.25 3.05245 1.42127 2.63896C1.64963 2.08765 2.08765 1.64963 2.63896 1.42127C3.05245 1.25 3.57663 1.25 4.625 1.25H5C5.69748 1.25 6.04622 1.25 6.33234 1.32667C7.1088 1.53472 7.71528 2.1412 7.92333 2.91766C8 3.20378 8 3.55252 8 4.25"
                    stroke="#555555" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                Resign</a>
            </li>
            <li>
              <a (click)="logout()">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M12.5 5L15.5 8M15.5 8L12.5 11M15.5 8H5.75M10.25 2.15303C9.29394 1.57871 8.18393 1.25 7 1.25C3.41015 1.25 0.5 4.27208 0.5 8C0.5 11.7279 3.41015 14.75 7 14.75C8.18393 14.75 9.29394 14.4213 10.25 13.847"
                    stroke="#555555" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                Log Out</a>
            </li>
          </ul>
        </div>
        }
      </div>
    </div>
  </div>
</div>
<div class="side-navbar">
  <ul>
    @if (!isEmployeeNot()) {
    <li>
      <a [routerLinkActive]="['active']" [routerLink]="['/dashboard-1']">
        <div class="svg-icon">
          <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M1 9.5653C1 8.99094 1 8.70376 1.07403 8.4393C1.1396 8.20503 1.24737 7.98469 1.39203 7.7891C1.55534 7.5683 1.78202 7.39199 2.23539 7.03937L9.0177 1.76424C9.36902 1.49099 9.54468 1.35436 9.73865 1.30184C9.9098 1.2555 10.0902 1.2555 10.2613 1.30184C10.4553 1.35436 10.631 1.49099 10.9823 1.76424L17.7646 7.03937C18.218 7.39199 18.4447 7.5683 18.608 7.7891C18.7526 7.98469 18.8604 8.20503 18.926 8.4393C19 8.70376 19 8.99094 19 9.5653V16.8002C19 17.9203 19 18.4804 18.782 18.9082C18.5903 19.2845 18.2843 19.5905 17.908 19.7822C17.4802 20.0002 16.9201 20.0002 15.8 20.0002H4.2C3.07989 20.0002 2.51984 20.0002 2.09202 19.7822C1.71569 19.5905 1.40973 19.2845 1.21799 18.9082C1 18.4804 1 17.9203 1 16.8002V9.5653Z"
              stroke="#155B5B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </div>
        <p>Dashboard</p>
      </a>
    </li>
    }
    @if (isEmployeeNot()) {
    <li>
      <a [routerLinkActive]="['active']" [routerLink]="['/new-admin-dashboard']">
        <div class="svg-icon">
          <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M1 9.5653C1 8.99094 1 8.70376 1.07403 8.4393C1.1396 8.20503 1.24737 7.98469 1.39203 7.7891C1.55534 7.5683 1.78202 7.39199 2.23539 7.03937L9.0177 1.76424C9.36902 1.49099 9.54468 1.35436 9.73865 1.30184C9.9098 1.2555 10.0902 1.2555 10.2613 1.30184C10.4553 1.35436 10.631 1.49099 10.9823 1.76424L17.7646 7.03937C18.218 7.39199 18.4447 7.5683 18.608 7.7891C18.7526 7.98469 18.8604 8.20503 18.926 8.4393C19 8.70376 19 8.99094 19 9.5653V16.8002C19 17.9203 19 18.4804 18.782 18.9082C18.5903 19.2845 18.2843 19.5905 17.908 19.7822C17.4802 20.0002 16.9201 20.0002 15.8 20.0002H4.2C3.07989 20.0002 2.51984 20.0002 2.09202 19.7822C1.71569 19.5905 1.40973 19.2845 1.21799 18.9082C1 18.4804 1 17.9203 1 16.8002V9.5653Z"
              stroke="#155B5B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </div>
        <p>Dashboard</p>
      </a>
    </li>
    }
    <label class="side-bar-label" (click)="toggleMenu()">
      Menu
      @if (isMenuVisible) {
      <i class="fa fa-angle-up"></i>
      }
      @if (!isMenuVisible) {
      <i class="fa fa-angle-down"></i>
      }
    </label>
    @if (isMenuVisible) {
    <li>
      <a [routerLink]="[setRouteAttendance()]" [routerLinkActive]="['active']"
        [routerLinkActiveOptions]="{exact: true}">
        <div class="svg-icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M16 4C16.93 4 17.395 4 17.7765 4.10222C18.8117 4.37962 19.6204 5.18827 19.8978 6.22354C20 6.60504 20 7.07003 20 8V17.2C20 18.8802 20 19.7202 19.673 20.362C19.3854 20.9265 18.9265 21.3854 18.362 21.673C17.7202 22 16.8802 22 15.2 22H8.8C7.11984 22 6.27976 22 5.63803 21.673C5.07354 21.3854 4.6146 20.9265 4.32698 20.362C4 19.7202 4 18.8802 4 17.2V8C4 7.07003 4 6.60504 4.10222 6.22354C4.37962 5.18827 5.18827 4.37962 6.22354 4.10222C6.60504 4 7.07003 4 8 4M9.6 6H14.4C14.9601 6 15.2401 6 15.454 5.89101C15.6422 5.79513 15.7951 5.64215 15.891 5.45399C16 5.24008 16 4.96005 16 4.4V3.6C16 3.03995 16 2.75992 15.891 2.54601C15.7951 2.35785 15.6422 2.20487 15.454 2.10899C15.2401 2 14.9601 2 14.4 2H9.6C9.03995 2 8.75992 2 8.54601 2.10899C8.35785 2.20487 8.20487 2.35785 8.10899 2.54601C8 2.75992 8 3.03995 8 3.6V4.4C8 4.96005 8 5.24008 8.10899 5.45399C8.20487 5.64215 8.35785 5.79513 8.54601 5.89101C8.75992 6 9.03995 6 9.6 6Z"
              stroke="#155B5B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </div>
        <p>Attendance</p>
      </a>
    </li>
    }
    @if (isMenuVisible) {
    <li>
      <a [routerLink]="[setRouteleave()]" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact: true}">
        <div class="svg-icon">
          <svg width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M19 9H1M14 1V5M6 1V5M5.8 21H14.2C15.8802 21 16.7202 21 17.362 20.673C17.9265 20.3854 18.3854 19.9265 18.673 19.362C19 18.7202 19 17.8802 19 16.2V7.8C19 6.11984 19 5.27976 18.673 4.63803C18.3854 4.07354 17.9265 3.6146 17.362 3.32698C16.7202 3 15.8802 3 14.2 3H5.8C4.11984 3 3.27976 3 2.63803 3.32698C2.07354 3.6146 1.6146 4.07354 1.32698 4.63803C1 5.27976 1 6.11984 1 7.8V16.2C1 17.8802 1 18.7202 1.32698 19.362C1.6146 19.9265 2.07354 20.3854 2.63803 20.673C3.27976 21 4.11984 21 5.8 21Z"
              stroke="#155B5B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </div>
        <p>Leave </p>
      </a>
    </li>
    }
    @if (isMenuVisible) {
    <li>
      <a [routerLinkActive]="['active']" [routerLink]="['/evaluation']">
        <div class="svg-icon">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M7 5H2.6C2.03995 5 1.75992 5 1.54601 5.10899C1.35785 5.20487 1.20487 5.35785 1.10899 5.54601C1 5.75992 1 6.03995 1 6.6V17.4C1 17.9601 1 18.2401 1.10899 18.454C1.20487 18.6422 1.35785 18.7951 1.54601 18.891C1.75992 19 2.03995 19 2.6 19H7M7 19H13M7 19L7 2.6C7 2.03995 7 1.75992 7.10899 1.54601C7.20487 1.35785 7.35785 1.20487 7.54601 1.10899C7.75992 1 8.03995 1 8.6 1L11.4 1C11.9601 1 12.2401 1 12.454 1.10899C12.6422 1.20487 12.7951 1.35785 12.891 1.54601C13 1.75992 13 2.03995 13 2.6V19M13 9H17.4C17.9601 9 18.2401 9 18.454 9.10899C18.6422 9.20487 18.7951 9.35785 18.891 9.54601C19 9.75992 19 10.0399 19 10.6V17.4C19 17.9601 19 18.2401 18.891 18.454C18.7951 18.6422 18.6422 18.7951 18.454 18.891C18.2401 19 17.9601 19 17.4 19H13"
              stroke="#155B5B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </div>
        <p>Evaluation</p>
      </a>
    </li>
    }
    @if (isMenuVisible) {
    <li>
      <a [routerLinkActive]="['active']" [routerLink]="['/payroll-main']">
        <div class="svg-icon">
          <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M7.5 13.6667C7.5 14.9553 8.54467 16 9.83333 16H12C13.3807 16 14.5 14.8807 14.5 13.5C14.5 12.1193 13.3807 11 12 11H10C8.61929 11 7.5 9.88071 7.5 8.5C7.5 7.11929 8.61929 6 10 6H12.1667C13.4553 6 14.5 7.04467 14.5 8.33333M11 4.5V6M11 16V17.5M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z"
              stroke="#155B5B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </div>
        <p>Payroll</p>
      </a>
    </li>
    }
    @if (isMenuVisible && EmployeeTab) {
    <li>
      <a [class.active]="isActiveAnnouncement()" [routerLink]="['/announcements']">
        <div class="svg-icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M13 3.5V6.2C13 7.88016 13 8.72024 13.327 9.36197C13.6146 9.92646 14.0735 10.3854 14.638 10.673C15.2798 11 16.1198 11 17.8 11H20.5M21 12.9882V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3H11.0118C11.7455 3 12.1124 3 12.4577 3.08289C12.7638 3.15638 13.0564 3.27759 13.3249 3.44208C13.6276 3.6276 13.887 3.88703 14.4059 4.40589L19.5941 9.59411C20.113 10.113 20.3724 10.3724 20.5579 10.6751C20.7224 10.9436 20.8436 11.2362 20.9171 11.5423C21 11.8876 21 12.2545 21 12.9882Z"
              stroke="#155B5B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </div>
        <p>Announcement</p>
      </a>
    </li>
    }
    @if (isMenuVisible) {
    <li>
      <a [routerLinkActive]="['active']" [routerLink]="['/company-policy']">
        <div class="svg-icon">
          <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M1 5.8C1 4.11984 1 3.27976 1.32698 2.63803C1.6146 2.07354 2.07354 1.6146 2.63803 1.32698C3.27976 1 4.11984 1 5.8 1H14.2C15.8802 1 16.7202 1 17.362 1.32698C17.9265 1.6146 18.3854 2.07354 18.673 2.63803C19 3.27976 19 4.11984 19 5.8V11.2C19 12.8802 19 13.7202 18.673 14.362C18.3854 14.9265 17.9265 15.3854 17.362 15.673C16.7202 16 15.8802 16 14.2 16H11.6837C11.0597 16 10.7477 16 10.4492 16.0613C10.1844 16.1156 9.9282 16.2055 9.68749 16.3285C9.41617 16.4671 9.17252 16.662 8.68521 17.0518L6.29976 18.9602C5.88367 19.2931 5.67563 19.4595 5.50054 19.4597C5.34827 19.4599 5.20422 19.3906 5.10923 19.2716C5 19.1348 5 18.8684 5 18.3355V16C4.07003 16 3.60504 16 3.22354 15.8978C2.18827 15.6204 1.37962 14.8117 1.10222 13.7765C1 13.395 1 12.93 1 12V5.8Z"
              stroke="#155B5B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </div>
        <p>Company Policy</p>
      </a>
    </li>
    }
    @if (isMangement()) {
    <label class="side-bar-label" (click)="toggleManagement()">
      MANAGMENT
      @if (isManagemntVisible) {
      <i class="fa fa-angle-up"></i>
      }
      @if (!isManagemntVisible) {
      <i class="fa fa-angle-down"></i>
      }
    </label>
    }
    <!-- hr login -->
    @if (isTeamManagement() && isManagemntVisible) {
    <li>
      <a [class.active]="isActiveTeamManagement()" [routerLink]="['/team-management']">
        <div class="svg-icon">
          <svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M21 19V17C21 15.1362 19.7252 13.5701 18 13.126M14.5 1.29076C15.9659 1.88415 17 3.32131 17 5C17 6.67869 15.9659 8.11585 14.5 8.70924M16 19C16 17.1362 16 16.2044 15.6955 15.4693C15.2895 14.4892 14.5108 13.7105 13.5307 13.3045C12.7956 13 11.8638 13 10 13H7C5.13623 13 4.20435 13 3.46927 13.3045C2.48915 13.7105 1.71046 14.4892 1.30448 15.4693C1 16.2044 1 17.1362 1 19M12.5 5C12.5 7.20914 10.7091 9 8.5 9C6.29086 9 4.5 7.20914 4.5 5C4.5 2.79086 6.29086 1 8.5 1C10.7091 1 12.5 2.79086 12.5 5Z"
              stroke="#155B5B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </div>
        <p>Team</p>@if (loannotification.total_count != 0 && user_role.role_type !== 'Team_Lead' && user_role.role_type
        !== 'Admin_AND_Team_Lead') {
        <span class="req-notify">
          {{loannotification.total_count}} </span>
        }
      </a>
    </li>
    }
    @if (isLeaveManagement() && isManagemntVisible) {
    <li>
      <a [class.active]="isActiveLeaves()" [routerLink]="['/show-leaves']">
        <div class="svg-icon">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M9 2H5.8C4.11984 2 3.27976 2 2.63803 2.32698C2.07354 2.6146 1.6146 3.07354 1.32698 3.63803C1 4.27976 1 5.11984 1 6.8V14.2C1 15.8802 1 16.7202 1.32698 17.362C1.6146 17.9265 2.07354 18.3854 2.63803 18.673C3.27976 19 4.11984 19 5.8 19H13.2C14.8802 19 15.7202 19 16.362 18.673C16.9265 18.3854 17.3854 17.9265 17.673 17.362C18 16.7202 18 15.8802 18 14.2V11M11 15H5M13 11H5M18.1213 1.87868C19.2929 3.05025 19.2929 4.94975 18.1213 6.12132C16.9497 7.29289 15.0503 7.29289 13.8787 6.12132C12.7071 4.94975 12.7071 3.05025 13.8787 1.87868C15.0503 0.707107 16.9497 0.707107 18.1213 1.87868Z"
              stroke="#155B5B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </div>
        <p> Leave </p> @if (notify.count != 0 && user_role.role_type !== 'Team_Lead' ) {
        <span class="req-notify">
          {{notify.count}} </span>
        }
      </a>
    </li>
    }
    @if (isAttendeanceManagement() && isManagemntVisible) {
    <li>
      <a [class.active]="isActiveAttendanceManagement()" [routerLink]="['/attendance-management']"
        (click)="setTodayAttendance()">
        <div class="svg-icon">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M9 2H5.8C4.11984 2 3.27976 2 2.63803 2.32698C2.07354 2.6146 1.6146 3.07354 1.32698 3.63803C1 4.27976 1 5.11984 1 6.8V14.2C1 15.8802 1 16.7202 1.32698 17.362C1.6146 17.9265 2.07354 18.3854 2.63803 18.673C3.27976 19 4.11984 19 5.8 19H13.2C14.8802 19 15.7202 19 16.362 18.673C16.9265 18.3854 17.3854 17.9265 17.673 17.362C18 16.7202 18 15.8802 18 14.2V11M11 15H5M13 11H5M18.1213 1.87868C19.2929 3.05025 19.2929 4.94975 18.1213 6.12132C16.9497 7.29289 15.0503 7.29289 13.8787 6.12132C12.7071 4.94975 12.7071 3.05025 13.8787 1.87868C15.0503 0.707107 16.9497 0.707107 18.1213 1.87868Z"
              stroke="#155B5B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </div>
        <p>Attendance </p> @if (Attendanceotificaton.total_count != 0 && user_role.role_type !== 'Team_Lead' &&
        user_role.role_type !== 'Admin_AND_Team_Lead') {
        <span class="req-notify">
          {{Attendanceotificaton.total_count}} </span>
        }
      </a>
    </li>
    }
    @if (isManagemntVisible && isPayrollManagement()) {
    <li>
      <a [routerLinkActive]="['active']" [routerLink]="['/payroll-summary']">
        <div class="svg-icon">
          <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M7.5 13.6667C7.5 14.9553 8.54467 16 9.83333 16H12C13.3807 16 14.5 14.8807 14.5 13.5C14.5 12.1193 13.3807 11 12 11H10C8.61929 11 7.5 9.88071 7.5 8.5C7.5 7.11929 8.61929 6 10 6H12.1667C13.4553 6 14.5 7.04467 14.5 8.33333M11 4.5V6M11 16V17.5M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z"
              stroke="#155B5B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </div>
        <p>Payroll</p>
      </a>
    </li>
    }
    <!-- @if (isAccountManagement() && isManagemntVisible) {
    <li>
      <a [routerLinkActive]="['active']" [routerLink]="isAdmin() ? '/admin-accounts' : '/accounts-managment'">
        <div class="svg-icon">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M15.5 15H4.5M15.5 11H4.5M1 7H19M5.8 1H14.2C15.8802 1 16.7202 1 17.362 1.32698C17.9265 1.6146 18.3854 2.07354 18.673 2.63803C19 3.27976 19 4.11984 19 5.8V14.2C19 15.8802 19 16.7202 18.673 17.362C18.3854 17.9265 17.9265 18.3854 17.362 18.673C16.7202 19 15.8802 19 14.2 19H5.8C4.11984 19 3.27976 19 2.63803 18.673C2.07354 18.3854 1.6146 17.9265 1.32698 17.362C1 16.7202 1 15.8802 1 14.2V5.8C1 4.11984 1 3.27976 1.32698 2.63803C1.6146 2.07354 2.07354 1.6146 2.63803 1.32698C3.27976 1 4.11984 1 5.8 1Z"
              stroke="#155B5B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </div>
        @if (isAdmin()) {
        <p> Accounts</p>
        } @else {
        <p>Accounts</p>
        }
      </a>
    </li>
    } -->
    @if (isTeamEvaluation() && isManagemntVisible) {
    <li>
      <a [class.active]="isActiveEvaluation()" [routerLink]="['/evaluation-list']">
        <div class="svg-icon">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M19 19H2.6C2.03995 19 1.75992 19 1.54601 18.891C1.35785 18.7951 1.20487 18.6422 1.10899 18.454C1 18.2401 1 17.9601 1 17.4V1M18 6L14.0811 10.1827C13.9326 10.3412 13.8584 10.4204 13.7688 10.4614C13.6897 10.4976 13.6026 10.5125 13.516 10.5047C13.4179 10.4958 13.3215 10.4458 13.1287 10.3457L9.87132 8.65433C9.67854 8.55423 9.58215 8.50418 9.48404 8.49534C9.39744 8.48753 9.31031 8.50245 9.23124 8.5386C9.14165 8.57957 9.06739 8.65883 8.91887 8.81734L5 13"
              stroke="#155B5B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </div>
        <p>Evaluation </p>
      </a>
    </li>
    }
    @if (isManagemntVisible && showAdmintab) {
    <li>
      <a [class.active]="isActiveAnnouncement()" [routerLink]="['/announcements']">
        <div class="svg-icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M13 3.5V6.2C13 7.88016 13 8.72024 13.327 9.36197C13.6146 9.92646 14.0735 10.3854 14.638 10.673C15.2798 11 16.1198 11 17.8 11H20.5M21 12.9882V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3H11.0118C11.7455 3 12.1124 3 12.4577 3.08289C12.7638 3.15638 13.0564 3.27759 13.3249 3.44208C13.6276 3.6276 13.887 3.88703 14.4059 4.40589L19.5941 9.59411C20.113 10.113 20.3724 10.3724 20.5579 10.6751C20.7224 10.9436 20.8436 11.2362 20.9171 11.5423C21 11.8876 21 12.2545 21 12.9882Z"
              stroke="#155B5B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </div>
        <p>Announcement</p>
      </a>
    </li>
    }
   
    @if (isEvent() && isManagemntVisible) {
    <li>
      <a [class.active]="isActiveEvent()" [routerLink]="['/event-management']">
        <div class="svg-icon">
          <svg width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M19 9H1M19 11.5V7.8C19 6.11984 19 5.27976 18.673 4.63803C18.3854 4.07354 17.9265 3.6146 17.362 3.32698C16.7202 3 15.8802 3 14.2 3H5.8C4.11984 3 3.27976 3 2.63803 3.32698C2.07354 3.6146 1.6146 4.07354 1.32698 4.63803C1 5.27976 1 6.11984 1 7.8V16.2C1 17.8802 1 18.7202 1.32698 19.362C1.6146 19.9265 2.07354 20.3854 2.63803 20.673C3.27976 21 4.11984 21 5.8 21H10M14 1V5M6 1V5M12.5 18L14.5 20L19 15.5"
              stroke="#155B5B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </div>
        <p>Event </p>
      </a>
    </li>
    }
    @if (isTeamHoliday() && isManagemntVisible) {
    <li>
      <a [class.active]="isActiveHolidays()" [routerLink]="['/holiday']">
        <div class="svg-icon">
          <svg width="20" height="22" viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M21 12C21 16.9706 16.9706 21 12 21C10.8029 21 9.6603 20.7663 8.61549 20.3419C8.41552 20.2607 8.31554 20.2201 8.23472 20.202C8.15566 20.1843 8.09715 20.1778 8.01613 20.1778C7.9333 20.1778 7.84309 20.1928 7.66265 20.2229L4.10476 20.8159C3.73218 20.878 3.54589 20.909 3.41118 20.8512C3.29328 20.8007 3.19933 20.7067 3.14876 20.5888C3.09098 20.4541 3.12203 20.2678 3.18413 19.8952L3.77711 16.3374C3.80718 16.1569 3.82222 16.0667 3.82221 15.9839C3.8222 15.9028 3.81572 15.8443 3.798 15.7653C3.77988 15.6845 3.73927 15.5845 3.65806 15.3845C3.23374 14.3397 3 13.1971 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
              stroke="#155B5B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </div>
        <p>Holiday's </p>
      </a>
    </li>
    }
    @if (isTeamResign() && isManagemntVisible) {
    <li>
      <a [routerLinkActive]="['active']" [routerLink]="['/resignation-list']">
        <div class="svg-icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M9 15H15M21 8H3M16 2V5M8 2V5M7.8 22H16.2C17.8802 22 18.7202 22 19.362 21.673C19.9265 21.3854 20.3854 20.9265 20.673 20.362C21 19.7202 21 18.8802 21 17.2V8.8C21 7.11984 21 6.27976 20.673 5.63803C20.3854 5.07354 19.9265 4.6146 19.362 4.32698C18.7202 4 17.8802 4 16.2 4H7.8C6.11984 4 5.27976 4 4.63803 4.32698C4.07354 4.6146 3.6146 5.07354 3.32698 5.63803C3 6.27976 3 7.11984 3 8.8V17.2C3 18.8802 3 19.7202 3.32698 20.362C3.6146 20.9265 4.07354 21.3854 4.63803 21.673C5.27976 22 6.11984 22 7.8 22Z"
              stroke="#155B5B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </div>
        <p>Resign's </p>
      </a>
    </li>
    }
    <!-- <li *ngIf="isTeamMedia() && isManagemntVisible">
                                            <a [routerLinkActive]="['active']" [routerLink]="['/add-news-updates']">
                                              <div class="nav-link-image-outer mr-1">
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                  <path
                                                    d="M8 16L12 12M12 12L16 16M12 12V21M20 16.7428C21.2215 15.734 22 14.2079 22 12.5C22 9.46243 19.5376 7 16.5 7C16.2815 7 16.0771 6.886 15.9661 6.69774C14.6621 4.48484 12.2544 3 9.5 3C5.35786 3 2 6.35786 2 10.5C2 12.5661 2.83545 14.4371 4.18695 15.7935"
                                                    stroke="#155B5B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                  </svg>
                                                </div>
                                                <p> Media</p>
                                              </a>
                                            </li> -->
    @if (isSettingManagement() && isManagemntVisible) {
    <li>
      <a [routerLinkActive]="['active']" [routerLink]="['/new-settings']">
        <div class="svg-icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
              stroke="#155B5B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path
              d="M18.7273 14.7273C18.6063 15.0015 18.5702 15.3056 18.6236 15.6005C18.6771 15.8954 18.8177 16.1676 19.0273 16.3818L19.0818 16.4364C19.2509 16.6052 19.385 16.8057 19.4765 17.0265C19.568 17.2472 19.6151 17.4838 19.6151 17.7227C19.6151 17.9617 19.568 18.1983 19.4765 18.419C19.385 18.6397 19.2509 18.8402 19.0818 19.0091C18.913 19.1781 18.7124 19.3122 18.4917 19.4037C18.271 19.4952 18.0344 19.5423 17.7955 19.5423C17.5565 19.5423 17.3199 19.4952 17.0992 19.4037C16.8785 19.3122 16.678 19.1781 16.5091 19.0091L16.4545 18.9545C16.2403 18.745 15.9682 18.6044 15.6733 18.5509C15.3784 18.4974 15.0742 18.5335 14.8 18.6545C14.5311 18.7698 14.3018 18.9611 14.1403 19.205C13.9788 19.4489 13.8921 19.7347 13.8909 20.0273V20.1818C13.8909 20.664 13.6994 21.1265 13.3584 21.4675C13.0174 21.8084 12.5549 22 12.0727 22C11.5905 22 11.1281 21.8084 10.7871 21.4675C10.4461 21.1265 10.2545 20.664 10.2545 20.1818V20.1C10.2475 19.7991 10.1501 19.5073 9.97501 19.2625C9.79991 19.0176 9.55521 18.8312 9.27273 18.7273C8.99853 18.6063 8.69437 18.5702 8.39947 18.6236C8.10456 18.6771 7.83244 18.8177 7.61818 19.0273L7.56364 19.0818C7.39478 19.2509 7.19425 19.385 6.97353 19.4765C6.7528 19.568 6.51621 19.6151 6.27727 19.6151C6.03834 19.6151 5.80174 19.568 5.58102 19.4765C5.36029 19.385 5.15977 19.2509 4.99091 19.0818C4.82186 18.913 4.68775 18.7124 4.59626 18.4917C4.50476 18.271 4.45766 18.0344 4.45766 17.7955C4.45766 17.5565 4.50476 17.3199 4.59626 17.0992C4.68775 16.8785 4.82186 16.678 4.99091 16.5091L5.04545 16.4545C5.25503 16.2403 5.39562 15.9682 5.4491 15.6733C5.50257 15.3784 5.46647 15.0742 5.34545 14.8C5.23022 14.5311 5.03887 14.3018 4.79497 14.1403C4.55107 13.9788 4.26526 13.8921 3.97273 13.8909H3.81818C3.33597 13.8909 2.87351 13.6994 2.53253 13.3584C2.19156 13.0174 2 12.5549 2 12.0727C2 11.5905 2.19156 11.1281 2.53253 10.7871C2.87351 10.4461 3.33597 10.2545 3.81818 10.2545H3.9C4.2009 10.2475 4.49273 10.1501 4.73754 9.97501C4.98236 9.79991 5.16883 9.55521 5.27273 9.27273C5.39374 8.99853 5.42984 8.69437 5.37637 8.39947C5.3229 8.10456 5.18231 7.83244 4.97273 7.61818L4.91818 7.56364C4.74913 7.39478 4.61503 7.19425 4.52353 6.97353C4.43203 6.7528 4.38493 6.51621 4.38493 6.27727C4.38493 6.03834 4.43203 5.80174 4.52353 5.58102C4.61503 5.36029 4.74913 5.15977 4.91818 4.99091C5.08704 4.82186 5.28757 4.68775 5.50829 4.59626C5.72901 4.50476 5.96561 4.45766 6.20455 4.45766C6.44348 4.45766 6.68008 4.50476 6.9008 4.59626C7.12152 4.68775 7.32205 4.82186 7.49091 4.99091L7.54545 5.04545C7.75971 5.25503 8.03183 5.39562 8.32674 5.4491C8.62164 5.50257 8.9258 5.46647 9.2 5.34545H9.27273C9.54161 5.23022 9.77093 5.03887 9.93245 4.79497C10.094 4.55107 10.1807 4.26526 10.1818 3.97273V3.81818C10.1818 3.33597 10.3734 2.87351 10.7144 2.53253C11.0553 2.19156 11.5178 2 12 2C12.4822 2 12.9447 2.19156 13.2856 2.53253C13.6266 2.87351 13.8182 3.33597 13.8182 3.81818V3.9C13.8193 4.19253 13.906 4.47834 14.0676 4.72224C14.2291 4.96614 14.4584 5.15749 14.7273 5.27273C15.0015 5.39374 15.3056 5.42984 15.6005 5.37637C15.8954 5.3229 16.1676 5.18231 16.3818 4.97273L16.4364 4.91818C16.6052 4.74913 16.8057 4.61503 17.0265 4.52353C17.2472 4.43203 17.4838 4.38493 17.7227 4.38493C17.9617 4.38493 18.1983 4.43203 18.419 4.52353C18.6397 4.61503 18.8402 4.74913 19.0091 4.91818C19.1781 5.08704 19.3122 5.28757 19.4037 5.50829C19.4952 5.72901 19.5423 5.96561 19.5423 6.20455C19.5423 6.44348 19.4952 6.68008 19.4037 6.9008C19.3122 7.12152 19.1781 7.32205 19.0091 7.49091L18.9545 7.54545C18.745 7.75971 18.6044 8.03183 18.5509 8.32674C18.4974 8.62164 18.5335 8.9258 18.6545 9.2V9.27273C18.7698 9.54161 18.9611 9.77093 19.205 9.93245C19.4489 10.094 19.7347 10.1807 20.0273 10.1818H20.1818C20.664 10.1818 21.1265 10.3734 21.4675 10.7144C21.8084 11.0553 22 11.5178 22 12C22 12.4822 21.8084 12.9447 21.4675 13.2856C21.1265 13.6266 20.664 13.8182 20.1818 13.8182H20.1C19.8075 13.8193 19.5217 13.906 19.2778 14.0676C19.0339 14.2291 18.8425 14.4584 18.7273 14.7273Z"
              stroke="#155B5B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </div>
        <p>Setting's </p>
      </a>
    </li>
    }
    <!-- <label class="side-bar-label" *ngIf="isEmployeeNot()">
                                                ACCTIVITIES
                                              </label> -->
  </ul>
</div>
</div>
}